export default {
  // Discord links (client/src/components/DiscordButton.tsx)
  discord: {
    joinTitle: "Join our Discord: share your videos and get featured",
    share: "Share on Discord",
    shareTitle: "Post it in #showcase on our Discord. We feature the best videos.",
  },
  // /audio-visualizer (client/src/pages/tools/AudioVisualizer.tsx)
  audioVisualizer: {
    drop: "Choose a song or drop it here",
    decoding: "Reading your song…",
    private: "Stays on your device",
    preview: "Visualizer preview",
    play: "Play",
    pause: "Pause",
    seek: "Position",
    change: "Change",
    styleLabel: "Style",
    styles: {
      bars: "Bars",
      wave: "Waveform",
      circle: "Circle",
      particles: "Particles",
    },
    sizeLabel: "Video size",
    colorsLabel: "Colors",
    palettes: {
      neon: "Neon",
      sunset: "Sunset",
      ocean: "Ocean",
      lime: "Lime",
      pastel: "Pastel",
      mono: "Mono",
      custom: "Custom color",
    },
    titlePlaceholder: "Title",
    artistPlaceholder: "Artist",
    addImage: "Background image",
    removeImage: "Remove image",
    export: "Export video",
    exportAgain: "Export again",
    recording: "Recording {{percent}}%",
    keepOpen: "Keep this tab open",
    cancel: "Cancel",
    download: "Download {{format}}",
    nextStep: "Want a real music video with scenes and a singer?",
    nextStepLink: "Try the AI music video generator",
    featuresHeading: "Features",
    faqHeading: "FAQ",
    errors: {
      decode: "Couldn't read that file. Try an MP3 or WAV.",
      image: "Couldn't open that image.",
      noRecorder: "This browser can't record video. Try a recent Chrome, Edge, Safari or Firefox.",
      blocked: "The browser blocked audio. Press Export again.",
      export: "Export failed. Please try again.",
    },
  },
  subscription: {
    title: "My Subscription",
    subtitle: "Manage your subscription and billing information.",
    account: "Account",
    emailAddress: "Email Address",
    notLoggedIn: "Not logged in",
    manageBilling: "Manage Billing",
    planLabel: "Plan",
    usage: "Usage",
    planNameSuffix: "Plan",
    legacyTag: "Legacy",
    yearlyTag: "Yearly",
    monthlyTag: "Monthly",
    creditsCount: "{{count}} Credits",
    popular: "Popular",
    current: "Current",
    downgrade: "Downgrade",
    creditsPerYear: "{{amount}} credits/year total • resets monthly",
    addonsTitle: "Need More Credits? Get Add-ons",
    addonsSubtitle: "One-time packs, no subscription required. Credits are valid for 12 months and don't auto-renew.",
    buyNow: "Buy Now",
    havingProblem: "Having a problem?",
    goToHelpCenter: "Go to Help center",
    cancelSubscription: "Cancel subscription",
    editBilling: "Edit billing",
    alertSignInCredits: "Please sign in to purchase credits",
    alertTopupNeedsSub: "Top-up credits require an active paid subscription. Please subscribe to a plan first.",
    alertSignInSubscribe: "Please sign in to subscribe",
    alertSignInBilling: "Please sign in to manage billing",
    errorPrefix: "Error: {{message}}",
    // Plans bought in the iOS / Android app (client/src/lib/storeBilling.ts)
    storeBilling: {
      googlePlay: {
        billedThrough: "Billed through Google Play",
        manage: "Manage in Google Play",
        note: "Your plan was bought in the Solmi app, so Google Play manages billing.",
        cancel: "Cancel or change it in Google Play",
        plansNote:
          "Your plan is billed through Google Play, so change it in the Solmi app. To switch to web billing, cancel in Google Play first, then subscribe here once your plan ends.",
      },
      appStore: {
        billedThrough: "Billed through the App Store",
        manage: "Manage in App Store",
        note: "Your plan was bought in the Solmi app, so the App Store manages billing.",
        cancel: "Cancel or change it in the App Store",
        plansNote:
          "Your plan is billed through the App Store, so change it in the Solmi app. To switch to web billing, cancel in the App Store first, then subscribe here once your plan ends.",
      },
    },
    pastDueBanner: {
      title: "Your payment didn't go through",
      body: "We couldn't charge your card for {{plan}} ({{amount}}). Update your payment details to keep your plan and credits.",
      bodyNoPlan:
        "We couldn't charge your card for your subscription. Update your payment details to keep your plan and credits.",
      cta: "Fix payment",
    },
    pendingCancelBanner: {
      title: "Your {{plan}} plan ends on {{date}}",
      body: "Keep it and we'll add {{credits}} bonus credits to your account right away.",
      cta: "Keep my plan",
      ctaBusy: "Keeping…",
      kept: "Welcome back! Your plan stays on and {{credits}} bonus credits were added.",
      failed: "We couldn't restart your plan. Please try again from Manage subscription.",
    },
    cancelFlow: {
      reasonTitle: "Before you go — what's not working?",
      reasonSubtitle:
        "Your feedback goes straight to the team and shapes what we fix next.",
      reasons: {
        too_expensive: "It's too expensive",
        not_using_enough: "I'm not using it enough",
        quality_results: "The results weren't good enough",
        missing_features: "It's missing features I need",
        technical_issues: "I ran into bugs or technical issues",
        other: "Something else",
      },
      detailPlaceholder: "Anything else you'd like us to know? (optional)",
      keepPlan: "Keep my plan",
      continue: "Continue",
      offerTitle: "Would a better deal change your mind?",
      offerSubtitle: "Keep everything you have today, for less.",
      offerYearlyHeadline: "Switch to yearly and save about 17%",
      offerYearlyBody:
        "Same plan, same credits every month — billed once a year at a lower rate.",
      offerHelp: "Hit a bug? Our team can usually fix it quickly —",
      switchToYearly: "Switch to yearly",
      offerDiscountHeadline: "Take 50% off your next payment",
      offerDiscountBody:
        "Keep your plan, credits and projects exactly as they are — your next renewal is half price. One-time offer.",
      offerSkipHeadline: "Skip a month instead",
      offerSkipBody:
        "We'll push your next renewal out by 30 days. No charge until then, and the credits you have stay yours. One-time offer.",
      takeDiscount: "Take 50% off",
      takeSkip: "Skip a month",
      offerApplying: "Applying…",
      savedTitle: "Done — your plan stays on",
      savedDiscountBody: "Your next payment will be 50% off. Nothing else changes.",
      savedSkipBody: "Your next renewal has moved out by 30 days. Your credits are untouched.",
      savedDone: "Back to my account",
      continueCancel: "No thanks, cancel",
      confirmTitle: "Cancel your subscription?",
      confirmBody:
        "Your plan stays active until the end of the current billing period, and you keep any remaining credits until then.",
      confirmBodyWithDate:
        "Your plan stays active until {{date}}, and you keep any remaining credits until then.",
      confirmCancel: "Cancel subscription",
      doneTitle: "Your subscription is set to cancel",
      doneBody:
        "You keep full access until the end of your current billing period. Your credits stay usable until then — come back and create anytime.",
      doneBodyWithDate:
        "You keep full access until {{date}}. Your credits stay usable until then — come back and create anytime.",
    },
  },
  directorPage: {
    projectOverview: "Project Overview",
    duration: "Duration",
    musicAnalysisResult: "Music analysis result",
    selectedSegment: "Selected segment",
    songLength: "Song length",
    leadCharacter: "Lead character",
    confidence: "Confidence",
    visualStyleResult: "Visual style result",
    finalVideo: "Final video",
    status: "Status",
    statusReadyWithSong: "Ready with song",
    statusAddingSong: "Adding song",
    statusPending: "Pending",
    prompt: "Prompt",
    attachedImages: "Attached images",
    noImage: "No image",
  },
  // Common
  deleteAccount: {
    menuLabel: "Delete account",
    title: "Delete account",
    description: "This permanently deletes your account, published songs, playlists, comments, and follows. Any active Solmi subscription billed through this site is canceled automatically. Subscriptions purchased through the App Store or Google Play are managed by Apple/Google and must be canceled there.",
    confirm: "Delete account",
    error: "Failed to delete account",
    sectionHint: "Account deletion is permanent and cannot be reversed.",
  },

  common: {
    loading: "Loading...",
    generating: "Generating...",
    generate: "Generate",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    download: "Download",
    share: "Share",
    play: "Play",
    pause: "Pause",
    signIn: "Sign In",
    signUp: "Sign Up for Free",
    logout: "Log out",
    viewProfile: "View Profile",
    manageSubscription: "Manage Subscription",
    reset: "Reset",
  },

  projects: {
    header: "Projects",
    newProject: "New project",
    search: "Search projects...",
    empty: "No projects yet",
    noMatches: "No matching projects",
    loadFailed: "Projects could not load.",
    retry: "Retry",
    open: "Open",
    complete: "Complete",
    untitled: "Untitled Project",
    rename: "Rename",
    renameTitle: "Rename project",
    renamed: "Project renamed",
    renameFailed: "Could not rename the project",
    delete: "Delete",
    deleteTitle: "Delete project?",
    deleteConfirm:
      "“{{title}}” and all of its generated content — including the finished video — will be permanently deleted. This cannot be undone, and credits spent on it are not refunded.",
    deleted: "Project deleted",
    deleteFailed: "Could not delete the project",
  },

  mobileAppPrompt: {
    openAppButton: "Open App",
    title: "Solmi is better on the app",
    appLabel: "Solmi App",
    open: "Open",
    browserLabel: "Web Browser",
    continue: "Continue",
  },

  // Auth Modal
  auth: {
    welcome: "Welcome to AI Song Generator",
    welcomeToSolmi: "Welcome to Solmi",
    signUpOrLogin: "Sign up or login to your account",
    freeCredits: "🎁 Free credits refill to 10 every day",
    startCreatingFree: "Start creating for free",
    perkStarterCredits: "100 free credits when you sign up",
    perkDailyCredits: "Free credits refill to 10 every day",
    perkNoCard: "No credit card required",
    signInWithGoogle: "Sign in with Google",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    appleUnavailable: "Apple sign-in is unavailable right now. Please try another method.",
    continueWithEmail: "Continue with your email",
    orDivider: "OR",
    orSignInWithEmail: "OR SIGN IN WITH EMAIL",
    enterEmail: "Enter your email",
    sendVerificationCode: "Send Verification Code",
    codeSent: "Verification code sent! Check your email.",
    sendCodeError: "Failed to send verification code",
    loginSuccess: "Login successful!",
    verifyCodeError: "Invalid verification code",
    invalidEmail: "Please enter a valid email address",
    invalidCode: "Please enter a 6-digit code",
    sending: "Sending...",
    backToEmail: "Back to email",
    codeSentTo: "We sent a verification code to",
    enterCode: "Enter 6-digit code",
    verifying: "Verifying...",
    verifyCode: "Verify Code",
    resendCode: "Resend code",
    legalAgreement:
      "By signing in, you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
  },

  // AI Cover
  aiCover: {
    title: "Create AI Cover with AI Voice Models",
    badge: "AI Cover",
    comingSoon: "Coming Soon",
    nowAvailable: "Now Available",
    allVoices: "All Voices",
    search: "Search",
    noVoicesFound: "No voices found matching your search.",
    categories: {
      all: "All",
      cartoon: "Cartoon",
      rapper: "Rapper",
      celebrity: "Celebrity",
      movie: "Movie",
      game: "Game",
      anime: "Anime",
      music: "Music",
    },
    backToAllVoices: "← Back to All Voices",
    backToAICover: "Back to AI Cover",
    voiceNotFound: "Voice model not found",
    aiVoice: "AI Voice",
    share: "Share",
    pasteYouTubeLink: "Paste A YouTube Link",
    noMoreThan7Minutes: "No More Than 7 Minutes",
    orDropAudioFile: "Or Drop An Audio File",
    fileRequirements:
      "No More Than 20MB. Support Wav, Mp3, M4a, Ogg, Flac, Aac, Aiff, Opus, Oga",
    clickToUpload: "Click to upload or drag and drop",
    creating: "Creating...",
    create: "Create",
    faqTitle: "FAQ - {{voiceName}} AI Voice",
    faqQ1: "How does AI voice cover work?",
    faqA1:
      "Our AI technology analyzes the uploaded audio and converts the vocals to sound like {{voiceName}} while preserving the melody, lyrics, and instrumentals.",
    faqQ2: "What audio formats are supported?",
    faqA2:
      "We support Wav, Mp3, M4a, Ogg, Flac, Aac, Aiff, Opus, and Oga formats with a maximum file size of 20MB.",
    faqQ3: "How long does it take to create a cover?",
    faqA3:
      "Processing typically takes 2-5 seconds for a 30-second audio clip, depending on the length of your input.",
    searchBySong: "Search by song name, voice",
    noCoversYet: "No AI covers created yet",
    createFirstCover: "Create your first cover!",
    untitledCover: "Untitled Cover",
    pending: "Pending",
    generating: "Generating...",
    failed: "Failed",
    generationFailed: "Generation failed",
    copiedSuccess: "Copied successfully!",
    copyFailed: "Failed to copy link",
    coverCreatedSuccess: "Voice cover created successfully!",
    coverCreationFailed: "Failed to create voice cover. Please try again.",
    generationStarted:
      "AI Cover generation started! You can refresh or close this page.",
    provideYouTubeOrFile:
      "Please provide a YouTube link or upload an audio file",
    fileUploadedSuccess: "File uploaded successfully!",
    uploadFailed: "Upload failed: {{error}}",
    fileTooLarge: "File size must be less than 20MB",
    invalidFileType:
      "Invalid file type. Supported: Wav, Mp3, M4a, Ogg, Flac, Aac, Aiff, Opus, Oga",
    // en-only for now; other languages fall back to en via fallbackLng.
    pitchTitle: "Vocal Pitch",
    pitchHint:
      "If the original singer and this voice are different genders, pick a shift so the cover stays in the voice's natural range.",
    pitchNoChange: "No Change",
    pitchMaleToFemale: "Male to Female",
    pitchFemaleToMale: "Female to Male",
    voiceCoverLabel: "AI Voice Cover",
    // Music Video Generator
    videoGenerator: {
      pageTitle: "AI Music Video Generator",
      pageSubtitle: "Animate your songs into immersive singing videos",
      dropAudioFileHere: "Drop your audio file here",
      uploadMusic: "Upload Music",
      musicHint: "MP3 or WAV, below 10 mins",
      uploadAudioCta: "Click to upload or drag and drop",
      uploadImage: "Upload Image",
      imageHint: "JPG, PNG, or WebP up to 10MB",
      uploadImageCta: "Click to upload or drag and drop",
      videoSettings: "Video Settings",
      orChooseCharacter: "Or choose a character",
      credits: "credits",
      enhanceImage: "Enhance the uploaded photo to be a singer (Optional)",
      enhancing: "Enhancing...",
      showLyrics: "Show lyrics",
      showLyricsHint: "Auto-detect and display lyrics as subtitles",
      makePublic: "Make video public",
      makePublicHint: "Allow others to discover your video",
      notice: "Videos typically generate within 1-2 minutes.",
      create: "Create Video",
      preview: "Live Preview",
      previewPlaceholder: "Upload assets to preview",
      processing: "Processing Video...",
      processingSubtitle: "This may take 1-2 minutes",
      failed: "Video generation failed",
      failedSubtitle: "Please adjust your inputs and try again.",
      ready: "Video ready!",
      started: "Video generation started",
      wavespeedUnauthorized:
        "Wavespeed rejected the request. Please double-check your API key configuration.",
      tooLarge: "File is larger than {{size}}MB.",
      audioTooLong:
        "Audio length must be under 10 minutes. Your audio is {{minutes}} minutes.",
      missingAssets: "Please upload both audio and an image.",
      imageEnhanced: "Image enhanced successfully!",
      trimNote:
        "Use the sliders below to select the audio segment you want to use. Only the selected portion will be used for video generation.",
      previouslyCreated: "Previously Created Videos",
      previouslyCreatedSubtitle: "Your AI music videos",
      uploadingAudio: "Uploading audio...",
      uploadingImage: "Uploading image...",
      start: "Start",
      duration: "Duration",
      defaultVideoTitle: "AI Music Video",
    },
    // AI Music Video Page Content
    page: {
      whatIsTitle: "What is AI Music Video Generator?",
      whatIsDescription:
        "AI Music Video Generator is a cutting-edge tool that transforms your audio tracks into professional-quality music videos with AI-powered lip-sync animation and auto-detected lyrics. Simply upload your song, choose a character, and watch as AI creates a stunning visual performance in minutes.",
      makePhotosSingTitle: "Make Photos Sing",
      makePhotosSingDescription:
        "Upload any photo and transform it into a singing character with precise lip-sync matching. Perfect for creating virtual performers, anime singers, or bringing portraits to life with music.",
      autoLyricsDetectionTitle: "Auto Lyrics Detection",
      autoLyricsDetectionDescription:
        "Our AI automatically detects and displays lyrics as animated subtitles, perfectly synchronized with your music. Great for lyric videos, karaoke content, and social media posts.",
      professionalQualityTitle: "Professional Quality",
      professionalQualityDescription:
        "Generate HD videos up to 720p with studio-quality animations. Export in vertical format optimized for TikTok, Instagram Reels, and YouTube Shorts.",
      creativeApplicationsTitle: "Creative Applications",
      lyricVideosTitle: "Lyric Videos",
      lyricVideosDescription:
        "Create engaging lyric videos with auto-generated subtitle animations. Perfect for lo-fi, jazz, ambient, and any music genre. Customize backgrounds and choose from various singing characters to match your musical style.",
      autoDetectLyrics: "Auto-detect lyrics from audio",
      synchronizedSubtitles: "Synchronized subtitle animations",
      customizablePerformers: "Customizable character performers",
      virtualSingerTitle: "Virtual Singer",
      virtualSingerDescription:
        "Build AI performers without appearing on camera. Generate unique virtual singers with custom voices and appearances. Perfect for artists who want to maintain privacy or create fictional band members.",
      preDesignedCharacters: "11+ pre-designed characters",
      uploadCustomPhotos: "Upload custom photos",
      realisticLipSync: "Realistic lip-sync animations",
      socialMediaContentTitle: "Social Media Content",
      socialMediaContentDescription:
        "Create viral music videos for TikTok, Instagram Reels, and YouTube Shorts. Vertical format (3:4 aspect ratio) optimized for mobile viewing and maximum engagement.",
      mobileOptimized: "Mobile-optimized vertical format",
      generateFast: "Generate in 1-2 minutes",
      downloadHDQuality: "Download HD quality (480p/720p)",
      musicPromotionTitle: "Music Promotion",
      musicPromotionDescription:
        "Independent musicians can create affordable, professional music videos for releases. Build visual content library for streaming platforms, social media, and promotional campaigns.",
      noExpensiveCosts: "No expensive video production costs",
      unlimitedVariations: "Create multiple video variations",
      commercialUse: "Commercial use with paid plans and credit packs",
      whoBenefitsTitle: "Who Can Benefit from AI Music Video Generator?",
      contentCreatorsTitle: "Content Creators",
      contentCreatorsDescription:
        "Generate viral music videos for TikTok, Instagram Reels, and YouTube Shorts. Create engaging content that stands out with professional lip-sync animations.",
      musiciansTitle: "Musicians & Artists",
      musiciansDescription:
        "Produce affordable music videos for releases without expensive production costs. Create visual content for every track in your catalog.",
      socialMediaManagersTitle: "Social Media Managers",
      socialMediaManagersDescription:
        "Create branded video content for marketing campaigns. Generate multiple video variations to test different characters and styles.",
      podcastersTitle: "Podcasters",
      podcastersDescription:
        "Add visual elements to podcast intros, outros, and promotional content. Transform audio segments into shareable video clips.",
      educatorsTitle: "Educators",
      educatorsDescription:
        "Create educational music videos that enhance learning retention. Make lessons more engaging with animated singing characters.",
      hobbyistsTitle: "Hobbyists",
      hobbyistsDescription:
        "Have fun bringing photos to life with music. Create personalized videos for friends, family, or special occasions.",
      faqTitle: "Frequently Asked Questions",
      faqAudioFormatsQ: "What audio formats are supported?",
      faqAudioFormatsA:
        "We support MP3 and WAV audio files up to 10 minutes in length. For best results, use high-quality audio files (320kbps MP3 or lossless WAV). Maximum file size is 70MB.",
      faqCommercialUseQ: "Can I use generated videos for commercial purposes?",
      faqCommercialUseA:
        "Yes! With our paid plans (Basic, Standard, Pro) or any one-time credit pack purchase, you have full commercial usage rights for the videos you generate. Free users can create videos for personal use. Always ensure you have rights to the audio you upload.",
      faqGenerationTimeQ: "How long does it take to generate a video?",
      faqGenerationTimeA:
        "Video generation typically takes 1-2 minutes, depending on the length of your audio and current server load. You'll receive a notification when your video is ready, and you can close the page while it processes.",
      faqImageFormatsQ: "What image formats can I upload?",
      faqImageFormatsA:
        'You can upload JPG, PNG, or WebP images up to 10MB. For best lip-sync results, use front-facing portraits with clearly visible facial features. You can optionally enable the "Enhance photo" feature to optimize your image for singing.',
      faqDownloadQ: "Can I download my videos?",
      faqDownloadA:
        "Yes! All generated videos are available for download in your chosen resolution (480p or 720p). Videos are stored permanently in your library, and you can re-download them anytime. Both resolutions cost the same (5 credits per video).",
      faqLanguagesQ: "What languages are supported for lyric detection?",
      faqLanguagesA:
        "Currently, English lyrics are detected with the highest accuracy. We're continuously improving our AI to support multiple languages including Spanish, French, German, Japanese, Korean, and Chinese. Auto-detection works best with clear, well-enunciated vocals.",
      faqLipSyncQ: "How accurate is the lip-sync?",
      faqLipSyncA:
        "Our AI achieves 90%+ lip-sync accuracy with clear vocal audio. The technology analyzes the audio waveform and matches mouth movements to phonemes in real-time. Results improve with higher quality audio and distinct vocal clarity.",
      faqOptimizeQ: "How can I optimize my results?",
      faqOptimizeA:
        'For best results: (1) Use high-quality audio with clear vocals, (2) Choose front-facing photos with good lighting if uploading custom images, (3) Enable "Show lyrics" for subtitle display, (4) Select characters that match your music genre, (5) Keep videos under 4 minutes for faster generation and better social media performance.',
    },
  },

  vocalRemover: {
    hero: {
      badge: "Studio-grade stems",
      title: "AI Vocal Remover & Karaoke Splitter",
      subtitle:
        "Upload any song or paste a YouTube link. Get separate vocal and instrumental stems in seconds with cloud-powered audio processing.",
      points: {
        highQuality: "High-quality stems",
        fastSplit: "Fast online processing",
        formats: "MP3 & WAV export",
      },
    },
    uploader: {
      title: "Upload your song",
      subtitle: "Supports MP3, WAV, M4A, FLAC, AAC, OGG (≤70MB)",
      uploadLabel: "Audio file",
      dropHighlight: "Drag and drop or click to choose an audio file",
      dropNote: "If you upload a file, it takes priority over a YouTube link.",
      orPaste: "Or paste a YouTube link",
    },
    settings: {
      format: "Output format",
      autoDownload: "Auto-download instrumental",
      autoDownloadHint:
        "Automatically download the karaoke stem after processing.",
    },
    tips: {
      title: "Quick tips",
      subtitle: "Get the cleanest possible split",
      item1:
        "Use the highest-quality source you have (lossless files give better results).",
      item2:
        "For live recordings or mashups, try multiple takes to find the best separation.",
      item3: "Need more control? Download both stems and mix inside your DAW.",
    },
    actions: {
      processing: "Separating vocals...",
      cta: "Split Vocals & Instrumental",
      download: "Download",
      clear: "Clear",
    },
    status: {
      success: "Vocal separation complete!",
    },
    errors: {
      noSource: "Please upload an audio file or paste a valid YouTube link.",
      tooLarge: "Audio file must be smaller than 70MB.",
      unsupported:
        "Unsupported audio format. Try MP3, WAV, M4A, FLAC, AAC, or OGG.",
    },
    results: {
      title: "Your split stems",
      defaultTitle: "Untitled track",
      instrumental: "Instrumental / Karaoke",
      instrumentalDesc:
        "Perfect for karaoke, remixes, covers, or backing tracks.",
      vocals: "Isolated Vocals",
      vocalsDesc: "Use the acapella for remixes, sampling, or analysis.",
    },
    steps: {
      title: "How it works",
      subtitle: "From upload to stems in under a minute",
      step1: {
        title: "1. Add your audio",
        description:
          "Upload up to 70MB or paste a YouTube link. We’ll fetch the audio automatically.",
      },
      step2: {
        title: "2. Choose output format",
        description:
          "Export high-quality WAV stems for mixing, or lightweight MP3s for sharing.",
      },
      step3: {
        title: "3. Download stems",
        description:
          "Preview both vocal and instrumental tracks online, then download instantly.",
      },
    },
    faq: {
      title: "Vocal remover FAQ",
      subtitle: "Everything you need to know",
      q1: "Does this change the quality of my song?",
      a1: "The original file stays untouched. We generate two new stems (vocals + instrumental) using an AI-powered filter so you can keep the source audio as-is.",
      q2: "Can I use the stems commercially?",
      a2: "You can remix, study, and practice with your stems. Always respect the copyright of the original song when publishing remixes or covers.",
      q3: "Why do some songs separate better than others?",
      a3: "Studio-recorded tracks with clear stereo imaging split best. Songs with heavy effects or crowd noise may produce artifacts—try multiple sources for the cleanest result.",
    },
    seo: {
      title: "How creators use the AI Vocal Remover",
      subtitle:
        "A few of the most common workflows supported by our stem splitter",
      producersTitle: "Remixers & music producers",
      producersDesc:
        "Remove vocals and keep the instrumental so you can drop clean stems into Ableton, FL Studio, or Logic for remixes, mashups, and genre flips without digging for multitracks.",
      vocalistsTitle: "Singers & vocal coaches",
      vocalistsDesc:
        "Generate lossless karaoke tracks to practice with live bands, or isolate acapellas so students can study vibrato, breath control, and pronunciation in detail.",
      contentTitle: "Content creators & streamers",
      contentDesc:
        "Create copyright-safe background beds for vlogs, livestreams, and podcasts. Split songs in seconds and use the instrumental under voiceovers without royalty headaches.",
      samplingTitle: "Sampling & sound design",
      samplingDesc:
        "Pull vocal hooks, chorus harmonies, or instrumental textures to chop and resample inside your DAW. Because stems are phase-aligned, layering is painless.",
      educatorsTitle: "Educators & researchers",
      educatorsDesc:
        "Demonstrate arrangement concepts by soloing or muting stems in real time. Isolated vocals and instrumentals make it easier to analyze mixing decisions or song structure.",
      stemTitle: "Studio-ready stems",
      stemDesc:
        "Every split delivers two downloadable files—instrumental and acapella—in WAV or MP3. No queues, no watermarks, ready for DAWs, DJ software, or live shows.",
    },
  },

  // Stem Splitter
  stemSplitter: {
    seoTitle:
      "AI Stem Splitter — Free AI Splitter for Vocals, Drums & Bass",
    seoDescription:
      "Free AI stem splitter. Split any song into vocals, drums, bass, and instruments for remixing, sampling, and production. Free account; 10 to 20 credits a song.",
    hero: {
      title: "AI Stem Splitter",
      subtitle:
        "Split your audio into separate stems using AI-powered source separation.",
      badge: "Beta",
    },
    input: {
      title: "Input",
      description: "Upload your audio file and choose separation mode.",
      uploadLabel: "Audio file",
      dropHighlight: "Drag and drop or click to choose an audio file",
      dropNote: "Supports MP3, WAV, M4A, FLAC, AAC, OGG (max 70MB)",
      orPaste: "Or paste a YouTube link",
    },
    separation: {
      title: "Separation variant",
      description: "Choose how you want to split your audio.",
      sixStem: "6-Stem separation",
      sixStemDesc: "Vocals, Drums, Bass, Guitar, Piano, Other",
      fourStem: "4-Stem separation",
      fourStemDesc: "Vocals, Drums, Bass, Other",
      twoStem: "2-Stem separation",
      twoStemDesc: "Vocals, Instrumental",
    },
    settings: {
      format: "Output format",
    },
    mix: {
      title: "Export mix",
      description:
        "Mute stems you do not want. The kept stems will be mixed into one downloadable track.",
      allKept: "All kept",
      mutedCount: "{{count}} muted",
      keep: "Keep",
      muted: "Muted",
      customMix: "Custom mix",
      customMixWithStems: "Custom mix ({{stems}})",
      presets: {
        all: "All",
        karaoke: "Karaoke",
        acapella: "Acapella",
        noDrums: "No drums",
        noBass: "No bass",
      },
    },
    output: {
      title: "Output",
      description:
        "Your last 15 stem splits are saved. Download any you want to keep.",
      noHistory: "No previous splits",
      noHistoryDesc: "Your stem split history will appear here.",
    },
    stems: {
      vocals: "Vocals",
      instrumental: "Instrumental",
      drums: "Drums",
      bass: "Bass",
      guitar: "Guitar",
      piano: "Piano",
      other: "Other",
    },
    actions: {
      split: "Split Audio",
      splitting: "Splitting...",
      download: "Download",
      downloadAll: "Download All",
      downloadAllStems: "Download all stems",
      downloadCustomMix: "Download mix",
      reset: "Reset",
      clear: "Clear",
    },
    results: {
      title: "Your stems",
      defaultTitle: "Untitled track",
      vocalsDesc: "Isolated vocals extracted from the mix.",
      instrumentalDesc: "Full instrumental backing track.",
      drumsDesc: "Drums and percussion isolated.",
      bassDesc: "Bass guitar and low frequencies.",
      guitarDesc: "Electric and acoustic guitars isolated.",
      pianoDesc: "Piano and keyboard instruments isolated.",
      otherDesc: "Other instruments (synths, strings, etc).",
      customMixDesc: "Your selected stems mixed into one track.",
      customMixDescWithStems: "Mixed from: {{stems}}.",
    },
    status: {
      started: "Stem separation started. Your stems will appear when processing finishes.",
      success: "Stem separation complete!",
      processing: "Processing...",
      failed: "Separation failed",
    },
    errors: {
      noSource: "Please upload an audio file or paste a valid YouTube link.",
      noStemsSelected: "Keep at least one stem in the mix.",
      tooLarge: "Audio file must be smaller than 70MB.",
      unsupported:
        "Unsupported audio format. Try MP3, WAV, M4A, FLAC, AAC, or OGG.",
      noCredits: "{{stems}}-stem separation costs {{cost}} credits. You have {{credits}}.",
      noCreditsTryFewer:
        "{{stems}}-stem separation costs {{cost}} credits. You have {{credits}}, enough for {{fewerStems}}-stem separation.",
      processingFailed: "Stem separation failed. Your credits were refunded.",
    },
    tips: {
      title: "Quick tips",
      subtitle: "Get the best stem separation results",
      item1: "Use high-quality source files for cleaner separation.",
      item2: "6-stem mode takes longer but gives you more control.",
      item3: "Studio recordings separate better than live recordings.",
    },
    credits: {
      twoStem: "10 credits",
      fourStem: "15 credits",
      sixStem: "20 credits",
    },
  },

  // Navigation
  nav: {
    featured: "Featured",
    tools: "Tools",
    aiMusic: "AI Music",
    aiCover: "AI Cover",
    aiMusicVideo: "AI Music Video",
    new: "NEW",
    vocalRemover: "Vocal Remover",
    stemSplitter: "Stem Splitter",
    songs: "Songs",
    playlists: "Playlists",
    create: "Create",
    library: "Library",
    pricing: "Pricing",
    blog: "Blog",
  },

  // Sections
  sections: {
    explore: "EXPLORE",
    create: "CREATE",
    library: "LIBRARY",
    tools: "TOOLS",
  },

  // Landing Page - Hero
  hero: {
    title: "Create Songs with Solmi AI",
    titleLine1: "Create Songs with",
    titleLine2: "Solmi AI",
    subtitle: "Create any song. Just describe it.",
    cta: "Start Creating Music For Free",
  },

  // Generator Tabs
  generator: {
    lyricsTab: "Lyrics to Song",
    descriptionTab: "Text to Song",

    // Settings
    settingsLabel: "Settings",

    // Title
    titleLabel: "Title (Optional)",
    titlePlaceholder: "Enter your title",
    titleCount: "{{count}} / 80",

    // Lyrics
    lyricsLabel: "Lyrics",
    lyricsPlaceholder: "Enter lyrics of your music or try to get inspired",
    lyricsCount: "{{count}} / 2000",
    writeLyricsForMe: "Write Lyrics For Me",
    writeLyricsModal: {
      title: "Enter the theme you want to write about",
      themeLabel: "Theme",
      themePlaceholder:
        "Describe the theme or topic for your lyrics (e.g., 'summer love', 'city life', 'dreams')",
      languageLabel: "Language",
      writeButton: "Write Lyrics",
    },

    // Description
    descriptionLabel: "Song Description",
    descriptionPlaceholder:
      "Describe the song you want to create (e.g., 'A happy upbeat pop song about summer')",
    descriptionCount: "{{count}} / 200",

    // Voice
    voiceLabel: "Voice",
    male: "Male",
    female: "Female",
    random: "Random",

    // Warnings
    sensitiveWarning:
      "Lyrics, titles, and styles must not contain names of famous people or sensitive words.",

    // Errors
    errorNoDescription: "Please enter a song description",
    errorNoSettings: "Please select at least one music setting",
    errorNoLyrics: "Please enter lyrics for your song",
    errorNoTitle: "Please enter a title to generate lyrics",

    // Success
    successGeneration: "Music generation started!",
    successLyrics: "Lyrics generated!",
  },

  // How It Works Section
  howItWorks: {
    title: "Create Your Masterpiece in 3 Simple Steps",
    subtitle: "From a spark of an idea to a full song in minutes.",

    step1Title: "1. Describe Your Song",
    step1Description:
      "Start with lyrics or a simple text description of the song you envision. Choose the mood, style, and vocals.",

    step2Title: "2. Let AI Work Its Magic",
    step2Description:
      "Our advanced AI analyzes your input and composes a unique piece of music, complete with vocals and instruments.",

    step3Title: "3. Download & Share",
    step3Description:
      "Listen to your creation, download the royalty-free track, and share it with the world. It's all yours!",
  },

  // Features Section
  features: {
    title: "Features of the AI Music Generator",
    subtitle:
      "Our AI music generator provides a variety of features that simplify the music creation process, making it easy and efficient.",

    // Text to Song
    textToSongTitle: "Text to Song",
    textToSongCta: "Try Text to Song Now",

    simpleDescriptionTitle: "Simple Description",
    simpleDescriptionText:
      "Simply describe your song idea in everyday language - no musical background required. Our AI captures and translates your vision flawlessly.",

    voiceControlTitle: "Voice Control",
    voiceControlText:
      "Select from male, female, or random vocals, or create instrumental tracks - offering complete flexibility for your musical goals.",

    // Lyrics to Song
    lyricsToSongTitle: "Lyrics to Song",
    lyricsToSongCta: "Create with Lyrics Now",

    styleCustomizationTitle: "Style Customization",
    styleCustomizationText:
      "Adjust your song with precise style preferences, genre specifications, and musical elements for a personalized outcome.",

    smartLyricsTitle: "Smart Lyrics Processing",
    smartLyricsText:
      "Our AI evaluates the emotion and rhythm of your lyrics to compose perfectly matched music, alongside options for spontaneous random lyrics inspiration.",

    // AI Cover
    aiCoverTitle: "AI Song Cover Generator",
    aiCoverDescription:
      "Transform any song into a unique cover using our collection of AI voice models. Upload your favorite track or a YouTube link, select from our curated voice models, and let our AI create a fresh cover while preserving the original melody and structure.",
    aiCoverLandingDescription:
      "Reimagine any song with different voices. Our AI can separate vocals and instrumentals, then swap the voice with any from our vast library.",
    aiCoverBadge: "AI Cover",
    aiCoverCta: "Try AI Cover Now",
    aiCoverTag1: "Voice Conversion",
    aiCoverTag2: "Vocal Isolation",
    aiCoverTag3: "Pitch Correction",
    aiCoverTag4: "Style Transfer",
    dropAudioFileHere: "Drop your audio file here",

    voiceCloningTitle: "Curated Voice Models",
    voiceCloningText:
      "Choose from our collection of pre-trained AI voice models including celebrities, cartoon characters, rappers, and more. Each model is optimized for high-quality voice conversion.",

    simpleInterfaceTitle: "Simple & Fast",
    simpleInterfaceText:
      "Upload your audio file or paste a YouTube link, select a voice model, and generate your cover in seconds. No complex settings needed.",

    // AI Music Video
    aiMusicVideoTitle: "Turn Your Songs Into Music Videos",
    aiMusicVideoDescription:
      "Transform your AI-generated songs or any audio into captivating music videos. Choose a character, upload your music, and watch AI bring your song to life with lip-synced animations and auto-detected lyrics.",
    aiMusicVideoCta: "Create Music Video",
    aiMusicVideoTag1: "Lip Sync Animation",
    aiMusicVideoTag2: "Auto Lyrics Detection",
    aiMusicVideoTag3: "Custom Characters",
    aiMusicVideoTag4: "HD Export",

    // Vocal Removal (Landing page section)
    vocalRemovalTitle: "AI Vocal Remover",
    vocalRemovalDescription:
      "Separate vocals and instrumentals from any song with AI-powered audio processing. Perfect for creating karaoke tracks, remixes, or isolating vocals for covers.",
    vocalRemovalLandingDescription:
      "Separate vocals from instrumentals with AI-powered precision. Create karaoke tracks, isolate vocals for remixes, or extract instrumentals for your projects.",
    vocalRemovalBadge: "Vocal Removal",
    vocalRemovalCta: "Try Vocal Remover",
    vocalRemovalTag1: "Vocal Isolation",
    vocalRemovalTag2: "Instrumental Extraction",
    vocalRemovalTag3: "High Quality",
    vocalRemovalTag4: "Fast Processing",
    vocalRemovalTagMultipleFormats: "Multiple Formats",
    uploadAudioToSeparate: "Upload audio to separate",
    vocals: "Vocals",
    instrumental: "Instrumental",

    // Features section (hardcoded text)
    textToAudioBadge: "Text to Audio",
    lyricsToSongBadge: "Lyrics to Song",
    textToSongDescription:
      "Describe your vision in plain English and let our advanced AI models compose, arrange, and produce a professional-quality track in seconds.",
    lyricsToSongDescription:
      "Turn your poetry or lyrics into a full song with vocals. Choose from various voice styles and genres to match your words perfectly.",
    smartUnderstanding: "Smart Understanding",
    smartUnderstandingDesc: "Understands complex musical terms and emotions.",
    fullControl: "Full Control",
    fullControlDesc: "Adjust tempo, instruments, and style.",
    professionalVocalSynthesis: "Professional vocal synthesis",
    automaticMelodyComposition: "Automatic melody composition",
    genreAdaptivePhrasing: "Genre-adaptive phrasing",
    multiLanguageSupport: "Multi-language support",
    tryItNow: "Try it now",

    // Mockup UI text
    aiMusicGenerator: "AI Music Generator",
    descriptionLabel: "Description",
    voiceLabel: "Voice",
    male: "Male",
    female: "Female",
    random: "Random",
    generating: "Generating...",
    lyricsEditor: "Lyrics Editor",
    aiVocalist: "AI Vocalist",
  },

  // Use Cases Section
  useCases: {
    title: "Who Can Benefit from Solmi AI?",
    contentCreators: "Content Creators",
    gameDevelopers: "Game Developers",
    marketers: "Marketers",
    students: "Students & Educators",
    musicians: "Musicians",
    hobbyists: "Hobbyists",
    aiEnthusiasts: "AI Enthusiasts",
    anyone: "Anyone!",
  },

  // Community Section
  community: {
    title: "Hear What Our Community Is Creating",
    summerVibes: "Summer Vibes",
    popUpbeat: "Pop, Upbeat",
    midnightDrive: "Midnight Drive",
    electronicChill: "Electronic, Chill",
    cityLights: "City Lights",
    hiphopLofi: "Hip-Hop, Lo-fi",
  },

  // FAQ Section
  faq: {
    title: "Frequently Asked Questions",

    q1: "Is the music really royalty-free?",
    a1: "Yes! All music you generate is 100% royalty-free. You can use it in your videos, podcasts, games, and any other commercial or non-commercial projects without any additional fees or licenses.",

    q2: "What kind of quality can I expect?",
    a2: "We use state-of-the-art AI models to generate high-quality, professional-sounding music. You can download your tracks in standard audio formats, ready for any use.",

    q3: "How many songs can I create?",
    a3: "Our free plan allows you to create a limited number of songs per day. Premium plans include a monthly credit allowance so you can create many more songs, plus more advanced features.",

    q4: "Can I use my own lyrics?",
    a4: "Absolutely! Our 'Lyrics to Song' feature is perfect for turning your poems, stories, or song lyrics into a complete musical piece. Just paste your text and let the AI do the rest.",

    q5: "What is AI Music Video and how does it work?",
    a5: "AI Music Video transforms your songs into captivating music videos with lip-synced animations. Simply upload your audio, choose a character, and our AI automatically detects lyrics and creates synchronized video content. Perfect for social media, YouTube, and promoting your music.",

    q6: "How does the AI Voice Cover feature work?",
    a6: "Our AI Voice Cover lets you transform any song with different AI voices. Upload your audio or provide a YouTube link, select from our library of AI voice models, and generate a cover version in seconds. Great for creating unique covers, parodies, or exploring how your song sounds with different vocal styles.",

    q7: "What is the Vocal Remover tool?",
    a7: "The Vocal Remover uses AI to separate vocals from instrumentals in any song. You can extract clean karaoke tracks, isolate vocals for remixing, or get instrumental versions for your projects. It works with most audio files and produces high-quality separated stems.",

    q8: "Can I create custom AI voices?",
    a8: "Yes! With our Custom Voice Training feature, you can train your own AI voice model. Upload voice samples, and our AI will learn the unique characteristics to create a personalized voice you can use for covers and original songs.",

    q9: "What genres and styles are supported?",
    a9: "Solmi AI supports a wide range of genres including Pop, Rock, Hip-Hop, R&B, Country, EDM, Jazz, Classical, Lo-Fi, K-Pop, Metal, and many more. You can also specify custom styles and moods to get exactly the sound you want.",
  },

  // Pricing Section
  pricing: {
    title: "Choose Your Creative Plan",
    subtitle: "Flexible plans and credit packs for every creator",
    getStarted: "Get Started",
    mostPopular: "Most Popular",

    // Plans
    // Current (2026 redesign): Free / Plus / Creator / Pro
    free: "Free",
    plus: "Plus",
    creator: "Creator",
    pro: "Pro",
    // Legacy — still referenced by some translation strings + grandfathered
    // copy in the FAQ. Safe to remove once no UI string uses them.
    basic: "Basic",
    standard: "Standard",
    prioritySupport: "Priority support",
    teamSupport3Days: "Team support within 3 business days",
    topupTitle: "Need More Credits? Get Add-ons",
    topupSubtitle:
      "One-time packs, no subscription required. Credits are valid for 12 months.",

    // Billing
    perWeek: "/week",
    perMonth: "/month",
    perYear: "/year",
    monthly: "Monthly",
    yearly: "Yearly",

    // Pricing features
    textLyricsToMusic: "Text/Lyrics to Music",
    aiLyricsGenerator: "AI Lyrics Generator",
    vocalRemoval: "Vocal Removal",
    coverSong: "Cover Song",
    cloudStorage30: "30 days cloud storage",
    cloudStorage365: "365 days cloud storage",
    cloudStorageUnlimited: "Unlimited cloud storage",
    aiMusicVideo: "AI Music Video",
    downloadMp3: "Download MP3",
    commercialUse: "Commercial Use",
    currentPlan: "Current Plan",
    dailyRefresh: "Daily refresh",
    equalsSongs: "Equals {{count}} songs",
    monthlyRefresh: "Monthly refresh",
    yearlyRefresh: "Yearly refresh",
    subscribeNow: "Subscribe Now",
    upgrade: "Upgrade",
    billedYearly: "Billed ${{amount}} yearly",

    // Features
    credits100: "1000 credits (100 songs)",
    credits500: "5000 credits (500 songs)",
    credits2400: "24000 credits (2400 songs)",
    newModel: "Access to new model (V2.0)",
    songsLength: "Songs up to 8 mins, 5K lyrics",
    noLimit: "No daily limit",
    unlimitedDownloads: "Unlimited downloads",
    priorityQueue: "Priority processing queue",
    standardSound: "Standard sound",
    customVibes: "Custom vibes & voices",
    uploadAudio: "Upload reference audio",
    premiumSound: "Premium sound",
    exportMidi: "Export MIDI files",
    vocalIsolator: "Vocal & instrumental isolator",

    // Upgrade modal — header / tabs / footer
    chooseYourPlan: "Choose your plan",
    chooseYourPlanSubtitle:
      "Top up credits or upgrade your plan to keep going.",
    chooseYourPlanDefaultDescription:
      "Unlock more credits and features to supercharge your creative workflow",
    loveYourSongTitle: "Love your song? Get the full experience!",
    yearlyDiscount: "17% off",
    topUpCreditsTab: "Top-up credits",
    viewAllPlans: "View all plans",
    closeAria: "Close",

    // Plan cards
    billedAnnually: "Billed annually",
    billedMonthly: "Billed monthly",
    getPlanCta: "Get {{plan}}",
    yourCurrentPlan: "Your current plan",
    redirecting: "Redirecting…",
    checkoutFailed: "Failed to start checkout. Please try again.",
    topupRequiresActive:
      "Top-up credits require an active paid subscription. Subscribe to a plan first.",

    // Plan headline credit labels (interpolated count)
    creditsDailyHeadline: "Credits refill to {{count}} daily",
    creditsMonthlyHeadline: "{{count}} monthly credits",
    freeCreditsHeadline:
      "100 music video credits, plus song credits that refill to 10 daily",

    // Plan credit bullets — short concrete-output lines under the headline
    enoughForExploration: "Enough for ~2 songs/day to explore",
    oneTimeVideoTrial: "100 starter video credits",
    starterVideoCoverage: "20s 480p video with watermark",
    freeOneTimeMusicVideo: "Starter credits cover one short 480p video with watermark",
    videoRendering720pWatermark: "480p video rendering with watermark",
    generateFullVideosPlus: "Generate ~3-7 full 1-min music videos",
    generateFullVideosCreator: "Generate ~9-15 full 1-min music videos",
    generateFullVideosPro: "Generate ~15-25 full 1-min music videos",
    generateFullVideosRange: "Generate ~{{min}}-{{max}} full 1-min music videos",
    creditStepsLabel: "Monthly credits",
    orSongsCount: "Or {{count}} AI songs",

    // Plan feature bullets
    videoRendering720p: "480p video rendering",
    videoRendering1080p: "720p & 1080p video rendering",
    noWatermarks: "No watermarks",
    aiSongGeneration: "AI song generation (text/lyrics)",
    vocalRemovalCoverSong: "Vocal Removal & Cover Song",
    downloadMp3Feature: "Download MP3",
    downloadMp3PersonalFeature: "Download MP3 (personal use)",

    // Top-up panel
    topupOneTimePacks:
      "One-time top-up packs. Credits added to your balance immediately and valid for 12 months.",
    topupRequiresActiveBanner: "Top-ups require an active paid subscription.",
    pickAPlanFirst: "Pick a plan first",
    topupNoPlanBanner:
      "No subscription needed — pack credits also unlock private projects and watermark-free downloads. Plans give you more credits per dollar.",
    comparePlans: "Compare plans",
    planSavingsHeadline:
      "{{plan}} would have saved you {{amount}} in the last 30 days",
    planSavingsPaidPacks: "Packs: {{amount}}",
    planSavingsPaidPlanAndPacks: "{{plan}} + packs: {{amount}}",
    planSavingsCostPlan: "{{plan}}: {{amount}}",
    planSavingsCostWithTopUps: "{{plan}} + top-ups: {{amount}}",
    shortfallNeeds_one:
      "This video needs {{count}} more credit.",
    shortfallNeeds_other:
      "This video needs {{count}} more credits.",
    coversThisVideoSpare_one:
      "Covers this video · {{count}} to spare",
    coversThisVideoSpare_other:
      "Covers this video · {{count}} to spare",
    coversThisVideo: "Covers this video",
    bestValue: "BEST VALUE",
    creditsLabelLower: "credits",
    needRecurringPrefix: "Need a recurring credit allowance? Switch to",
    needRecurringSuffix: "plans.",
    monthlyOrYearlySwitch: "Monthly or Yearly",
  },

  // Upgrade modal FAQ ("Frequently Asked Questions")
  pricingFaq: {
    sectionTitle: "Frequently Asked Questions",
    items: {
      autorenew: {
        q: "Is my subscription automatically renewed? How do I cancel?",
        a: "Paid plans renew automatically each billing period. You can cancel from Manage Billing on the subscription page, and your plan stays active until the end of the period you have already paid for.",
      },
      changePlan: {
        q: "Can I change my plan after purchase?",
        a: "Yes. Use Manage Billing to switch plans or update your billing details. Stripe will show any immediate charge, credit, or scheduled change before you confirm.",
      },
      howMany: {
        q: "How many songs or music videos can I generate?",
        a: "Songs currently cost 5 credits each. Music-video usage depends on length and selected workflow: Plus includes 2,000 monthly credits for about 3-7 full 1-minute music videos or 400 AI songs, Creator includes 5,500 credits for about 9-15 videos or 1,100 AI songs, and Pro includes 9,000 credits for about 15-25 videos or 1,800 AI songs.",
      },
      commercial: {
        q: "Can I use generated songs or videos commercially?",
        a: "Commercial use is included with paid plans and one-time credit pack purchases. Free plan creations are intended for personal use and may include watermarks or other free-tier limits.",
      },
      ownership: {
        q: "Who owns the generated content?",
        a: "Solmi does not claim ownership of the songs, lyrics, images, videos, or prompts you create. You are responsible for making sure any uploaded inputs are yours to use, and AI copyright rules can vary by location.",
      },
      howCreditsWork: {
        q: "How do credits work?",
        a: "Credits are the unit used for song generation, cover songs, vocal removal, stem splitting, AI music videos, and every edit, regeneration, or re-render of a frame or clip. Paid-plan credits refresh up to your monthly allowance each cycle, including yearly plans, and top-up credits sit on top of that balance. Unused plan credits do not carry over and expire when your subscription ends, while top-up credits stay on your account for 12 months from purchase.",
      },
      editsCost: {
        q: "Do edits and re-renders cost credits?",
        a: "Yes. Every storyboard frame regeneration and every clip re-render is charged per shot, at the price shown on the button, because the video model generates that shot again from scratch. Corrections after a video is finished are new generations, not free revisions. To keep costs low, put style and movement instructions in your opening prompt so the whole video follows them, and re-render only the shots that need to change.",
      },
      addonPackages: {
        q: "What are add-on credit packages?",
        a: "Add-on packages are one-time credit purchases for anyone who needs more generation capacity — no subscription required. They do not auto-renew and are valid for 12 months.",
      },
      buyExtra: {
        q: "How can I purchase extra credits?",
        a: "Open the Top-up credits tab in the pricing popup or use the add-on section on the subscription page. Purchased credits are added to your balance after checkout completes.",
      },
      support: {
        q: "How do I get support, and how fast will you respond?",
        a: "Solmi is a self-serve product: you create and edit your videos yourself with our tools, and our team does not make or edit videos on users' behalf. For account, billing, or product issues, paid users get team support: email support@solmi.ai from your account email with a link to the project, and a team member will reply within 3 business days. Free plan users can also write to support@solmi.ai, although replies are not guaranteed within a set timeframe.",
      },
      refundPolicy: {
        q: "What is your refund policy?",
        a: "AI Results: Generative output varies by nature and no specific result is guaranteed, so dissatisfaction with a particular song or video is not, on its own, grounds for a refund.\nPartial Refunds: We don't offer partial or prorated refunds on any plan or product.\nSubscriptions: A subscription qualifies for a full refund only while it is completely unused and unexpired, and only on the first purchase. Renewal charges are not refundable.\nCredits: Credit packs and top-ups are final once purchased, whether or not the credits have been spent.\nApp Store Purchases: Purchases billed by Apple or Google are governed by that store's own refund process.\nAdditional Notes: Free trials, bonus credits, and promotional gifts have no refund value. This policy may be revised over time, and the current version applies to all purchases.",
      },
    },
  },

  // Resource Section
  resources: {
    title: "Resource",
    christmasSong: "Christmas Song",
    countrySong: "Country Song",
    metalSong: "Metal Song",
    loveSong: "Love Song",
    kpopSong: "Kpop Song",
    lofiSong: "Lofi Song",
    rapSong: "Rap Song",
    createTips: "Create Tips",
    musicTips: "Music Tips",
    musicNews: "Music News",
  },

  // Music Settings
  musicSettings: {
    title: "Settings",
    subtitle: "Select your desired music characteristics",
    reset: "Reset",
    confirm: "Confirm",
    styleTitle: "Style",
    moodTitle: "Mood",
    scenarioTitle: "Scenario",
    // Styles
    pop: "Pop",
    folk: "Folk",
    rnb: "R&B",
    hiphop: "Hip Hop",
    urban: "Urban",
    rock: "Rock",
    jazz: "Jazz",
    electronic: "Electronic",
    classical: "Classical",
    disco: "Disco",
    reggae: "Reggae",
    blues: "Blues",
    country: "Country",
    experimental: "Experimental",
    world: "World Music",
    ethnic: "Ethnic",
    // Moods
    relaxed: "Relaxed",
    happy: "Happy",
    energetic: "Energetic",
    romantic: "Romantic",
    sad: "Sad",
    angry: "Angry",
    inspired: "Inspired",
    warm: "Warm",
    passionate: "Passionate",
    joyful: "Joyful",
    longing: "Longing",
    // Scenarios
    coffeeShop: "Coffee Shop",
    solitaryWalk: "Solitary Walk",
    travel: "Travel",
    sunsetBySea: "Sunset by Sea",
    quietEvening: "Quiet Evening",
    lateNightBar: "Late Night Bar",
    urbanRomance: "Urban Romance",
    cityNightlife: "City Nightlife",
    rainyNight: "Rainy Night",
    sunlitShores: "Sunlit Shores",
  },

  // Footer
  footer: {
    copyright: "© {{year}} Solmi AI. All Rights Reserved.",
    about: "About",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    contact: "Contact",
  },

  songs: {
    publish: "Publish",
    unpublish: "Unpublish",
    unpublishConfirm: "Are you sure you want to unpublish?",
    publishDescription:
      "Publishing allows others to use your work as reference for similar songs",
    songTitle: "Song title",
    enterSongTitle: "Enter song title",
    songCover: "Song cover",
    size: "Size",
    removeCover: "Remove cover",
    noCover: "No cover image",
    publishing: "Publishing...",
    unpublishing: "Unpublishing...",
    published: "Published",
  },

  featured: {
    subtitle: "Discover amazing songs created by our community",
    heroLead: "Music videos",
    heroAccent: "worth sharing.",
    makeYourOwn: "Make yours",
    tabTrending: "Trending",
    tabNew: "New",
    tabFollowing: "Following",
    formatVertical: "Vertical",
    formatWide: "Widescreen",
    allStyles: "All styles",
    staffPick: "Staff pick",
    staffPicksTitle: "Staff picks",
    staffPickAdded: "Added to staff picks",
    staffPickRemoved: "Removed from staff picks",
    untitled: "Untitled",
    creatorFallback: "Solmi creator",
    playVideo: "Play {{title}}",
    likeVideo: "Like {{title}}",
    shareVideo: "Share {{title}}",
    playsCount_one: "{{count}} play",
    playsCount_other: "{{count}} plays",
    like: "Like",
    share: "Share",
    follow: "Follow",
    following: "Following",
    followCreator: "Follow {{name}}",
    remix: "Make one like this",
    remixShort: "Remix",
    remixLoaded: "Song, style and prompt loaded. Add your own cast.",
    upNext: "Up next",
    close: "Close",
    play: "Play",
    pause: "Pause",
    mute: "Mute",
    unmute: "Unmute",
    tapForSound: "Tap for sound",
    previousVideo: "Previous video",
    nextVideo: "Next video",
    copyLink: "Copy link",
    shareOnX: "Share on X",
    shareOnFacebook: "Share on Facebook",
    moreShareOptions: "More options",
    linkCopied: "Link copied",
    copyFailed: "Couldn't copy the link",
    likeFailed: "Couldn't save that like.",
    followFailed: "Couldn't update follow.",
    signIn: "Sign in",
    followingSignIn: "Sign in to see new videos from creators you follow.",
    followingEmpty: "Follow creators to see their new videos here.",
    empty: "No videos match these filters yet.",
    browseTrending: "Browse trending",
    loadMore: "Load more",
    songsTitle: "Songs to make a video for",
    makeVideo: "Make a video",
    makeVideoForSong: "Make a video for {{title}}",
    authorVideos: "Videos",
    authorSongs: "Songs",
    comments: "Comments",
    noComments: "No comments yet. Say something nice.",
    addComment: "Add a comment…",
    postComment: "Post",
    signInToComment: "Sign in to comment",
    commentOptions: "Comment options",
    deleteComment: "Delete",
    creatorTag: "Creator",
    commentFailed: "Couldn't post that comment.",
    commentTooFast: "You're commenting too fast. Try again in a minute.",
    commentDeleteFailed: "Couldn't delete that comment.",
  },

  playlists: {
    title: "Playlists",
    header: "LIBRARY",
    subtitle: "Organize your AI songs and keep your favorites together.",
    newPlaylist: "Create Playlist",
    signIn: "Sign in to create and manage your playlists.",
    emptyState: "You haven't created any playlists yet.",
    createFirst: "Create your first playlist",
    songCount: "{{count}} songs",
    playlistName: "Playlist name",
    playlistDescription: "Description (optional)",
    savePlaylist: "Save",
    created: "Playlist created",
    createFailed: "Failed to create playlist",
  },

  // Video Detail Page
  videoDetail: {
    editLyrics: "Edit Lyrics",
    editLyricsDescription: "Correct the words, keeping one line per timed caption. Saving re-exports the video for free.",
    editLyricsLineCount: "{{lines}} timed lines",
    editLyricsMismatch: "This video has {{expected}} timed caption lines and your edit has {{actual}}. Correct the words without adding or removing lines so the timing stays in sync.",
    editLyricsSave: "Save & Re-export Free",
    editLyricsSaving: "Re-exporting…",
    editLyricsPosition: "Caption position",
    editLyricsPositionCenter: "Center",
    editLyricsPositionBottom: "Bottom",
    editLyricsTextSize: "Text size",
    editLyricsTextSizeSmall: "Small",
    editLyricsTextSizeMedium: "Medium",
    editLyricsTextSizeLarge: "Large",
    editLyricsTextSizeXLarge: "Extra large",
    editLyricsTextColor: "Text color",
    editLyricsBackground: "Background",
    editLyricsBackgroundCurrent: "Current",
    editLyricsBackgroundUpload: "Upload",
    editLyricsBackgroundUploadFailed: "Could not upload that image. Please try another one.",
    editLyricsTitleCard: "Song title at the start",
    editLyricsTitleCardTitle: "Song title",
    editLyricsTitleCardArtist: "Artist (optional)",
    lyricsUpdated: "Your corrected lyrics video was re-exported for free.",
    lyricsUpdateFailed: "Could not update lyrics. Please try again.",
    back: "Back",
    loading: "Loading...",
    videoNotFound: "Video not found",
    untitledVideo: "Untitled Video",
    download: "Download",
    share: "Share",
    editTitle: "Edit Title",
    publish: "Publish",
    unpublish: "Unpublish",
    prompt: "Prompt",
    cancel: "Cancel",
    save: "Save",
    editVideoTitle: "Edit Video Title",
    enterVideoTitle: "Enter video title",
    videoPublishedSuccess: "Video published successfully!",
    videoPublishFailed: "Failed to publish video",
    videoUnpublishedSuccess: "Video unpublished successfully!",
    videoUnpublishFailed: "Failed to unpublish video",
    videoTitleUpdated: "Video title updated!",
    videoTitleUpdateFailed: "Failed to update video title",
    videoDownloadedSuccess: "Video downloaded successfully!",
    videoDownloadFailed: "Failed to download video. Please try again.",
    copiedSuccess: "Copied successfully!",
    copyFailed: "Failed to copy link",
  },

  // Library Page
  // Post-song dialog on the song pages (MusicVideoPromptDialog).
  songToVideoPrompt: {
    title: "Turn this song into a music video?",
    titleFree: "Make a free video for this song?",
    body: "Use \"{{title}}\" as the soundtrack and create matching AI visuals.",
    bodyFree: "Your account includes one free 20-second preview, with \"{{title}}\" as the soundtrack.",
    cta: "Create music video",
    ctaFree: "Make my free preview",
    dismiss: "Not now",
    thisSong: "this song",
  },
  library: {
    title: "My Library",
    subtitle: "Your creative masterpieces",
    tabs: {
      aiMusic: "AI Music",
      aiCover: "AI Cover",
      aiMusicVideo: "AI MV",
    },
    createButtons: {
      createMusic: "Create Music",
      createCover: "Create Cover",
      createMusicVideo: "Create MV",
      createVideo: "Create Video",
    },
    emptyStates: {
      noMusic: "No AI Music Yet",
      noMusicDescription: "Start creating your first AI-generated song",
      noCovers: "No AI Covers Yet",
      noCoversDescription: "Start creating your first AI voice cover",
      noVideos: "No AI Videos Yet",
      noVideosDescription: "Start creating your first AI music video",
    },
    noDescription: "No description",
    published: "Published",
    unpublish: "Unpublish",
  },

  // SEO - Page Titles and Descriptions
  seo: {
    landing: {
      title: "Solmi AI - AI Song Maker & Music Generator",
      description:
        "Solmi AI is the ultimate AI song maker and music generator platform - create original songs, AI covers and full productions with our AI music generator.",
    },
    home: {
      title: "AI Music Generator - Create Songs with AI | Solmi AI",
      description:
        "Create original songs with Solmi's AI music generator. Generate music from text, add custom lyrics, and produce professional tracks in any genre. Free to start.",
    },
    aiCover: {
      title: "AI Cover Generator - Create Voice Covers with AI | Solmi AI",
      description:
        "Re-sing a song in a new AI voice: upload a track, choose a voice, and Solmi swaps the vocal while keeping the original instrumental. Free to start, no card.",
    },
    aiMusicVideo: {
      title: "AI Music Video Generator - Create Singing Videos | Solmi AI",
      description:
        "Transform your songs into stunning AI music videos. Animate photos to sing, add auto-detected lyrics, and create viral content for TikTok, YouTube, and Instagram. Free to start.",
    },
    vocalRemover: {
      title: "Vocal Remover - Separate Vocals from Music | Solmi AI",
      description:
        "Remove vocals from any song with AI. Separate vocals and instrumentals in seconds. Perfect for karaoke, remixes, and music production. Download high-quality stems. Free to try.",
    },
    customVoice: {
      title: "Custom Voice Creation - Train Your AI Voice | Solmi AI",
      description:
        "Create your own AI voice model. Train custom voices for covers and music creation. Upload samples and get your personalized AI voice in minutes.",
    },
    blog: {
      title: "Blog - AI Music Creation Tips & Updates | Solmi AI",
      description:
        "Discover tips, tutorials, and updates about AI music creation. Learn how to make songs, covers, and music videos with Solmi AI.",
    },
    comparison: {
      title:
        "Solmi AI vs Suno vs Udio: Best AI Music Generator Comparison 2026",
      description:
        "Compare the top AI music generators. See how Solmi AI stacks up against Suno and Udio in features, pricing, quality, and more. Find the best AI music tool for your needs.",
    },
  },

  // SEO Landing Pages
  seoPages: {
    aiSongGenerator: {
      title: "AI Song Generator",
      seoTitle:
        "AI Song Generator - Create Original Songs with AI Free | Solmi",
      description:
        "Create original songs in seconds with Solmi's AI song generator. Describe your idea, choose a genre, and get a complete song with vocals, lyrics, and production. Free to start, no music experience needed.",
      heroSubtitle:
        "Describe your idea in words and let AI create a full song with vocals, lyrics, and professional production — in seconds.",
    },
    songMaker: {
      title: "Song Maker",
      seoTitle: "Song Maker - Make Your Own Song Online Free | Solmi AI",
      description:
        "Make your own songs online with Solmi's AI song maker. No instruments or music theory needed — just describe what you want and get a complete, professional song in seconds. Free to use.",
      heroSubtitle:
        "The easiest way to make your own song. Just type what you want and get a complete track with vocals, instruments, and production.",
    },
    aiMusicMaker: {
      title: "AI Music Maker",
      seoTitle: "AI Music Maker - Create Music with AI Online Free | Solmi",
      description:
        "Create music with AI using Solmi's music maker. Generate professional tracks in any genre — pop, hip-hop, EDM, lo-fi, and more. Full production with vocals and instrumentals. No skills required.",
      heroSubtitle:
        "Make professional music in any genre with AI. From beats to full songs with vocals — create, download, and share your music.",
    },
    aiSongMaker: {
      title: "AI Song Maker",
      seoTitle: "AI Song Maker - Make Songs with AI Free | Solmi",
      description:
        "Make songs with AI using Solmi's AI song maker. Transform your ideas into complete songs with vocals, lyrics, and studio-quality production. 50+ genres, any language. Free to start.",
      heroSubtitle:
        "Turn any idea into a real song. Our AI handles vocals, lyrics, melody, and production — you just provide the inspiration.",
    },
    aiLyricsGenerator: {
      title: "AI Lyrics Generator",
      seoTitle: "AI Lyrics Generator - Write Song Lyrics with AI Free | Solmi",
      description:
        "Write song lyrics with AI using Solmi's lyrics generator. Get creative, rhyming lyrics for any genre or mood. Then turn them into a full song with AI vocals and production. Free to try.",
      heroSubtitle:
        "Stuck on lyrics? Let AI help you write the perfect words. Generate lyrics for any genre, then turn them into a complete song.",
    },
    lyricsToSong: {
      title: "Lyrics to Song",
      seoTitle: "Lyrics to Song - Turn Your Lyrics Into a Real Song | Solmi",
      description:
        "Turn your lyrics into a real song with Solmi AI. Paste your words, choose a genre and mood, and get a professionally produced song with AI vocals and full instrumentation.",
      heroSubtitle:
        "Already have lyrics? Paste them in, pick a style, and hear your words come to life as a full song with vocals and instruments.",
    },
    textToSong: {
      title: "Text to Song AI",
      seoTitle: "Text to Song AI - Convert Text Into Music Free | Solmi",
      description:
        "Convert any text into a song with Solmi AI. Type a description, story, poem, or message and transform it into a complete song with vocals, melody, and production. Free and instant.",
      heroSubtitle:
        "Type any text — a story, a message, a poem — and watch AI transform it into a real song with vocals and music.",
    },
    aiSongwriter: {
      title: "AI Songwriter",
      seoTitle:
        "AI Songwriter - Write and Produce Songs with AI | Solmi",
      description:
        "Meet your AI songwriting assistant. Solmi helps you write lyrics, compose melodies, and produce complete songs. Whether you're a beginner or pro, create radio-ready songs faster with AI.",
      heroSubtitle:
        "Your personal AI songwriting partner. From lyrics to melody to full production — create professional songs in minutes, not months.",
    },
    howItWorks: {
      step1Title: "Describe Your Song",
      step1Description:
        "Type a description of the song you want — a theme, mood, story, or occasion. Or paste your own lyrics.",
      step2Title: "Choose Your Style",
      step2Description:
        "Pick from 50+ genres including pop, rock, hip-hop, jazz, EDM, lo-fi, country, and more.",
      step3Title: "Generate & Download",
      step3Description:
        "AI creates your complete song with vocals, instrumentals, and lyrics. Download or share it instantly.",
    },
    features: {
      aiVocals: "AI-Powered Vocals",
      aiVocalsDesc:
        "Natural-sounding vocals generated from your lyrics with realistic expression and emotion.",
      genres: "50+ Genres",
      genresDesc:
        "From pop to lo-fi, hip-hop to classical — create songs in any style you can imagine.",
      fast: "Ready in Seconds",
      fastDesc:
        "No waiting hours. Get a full, radio-quality song generated in under 30 seconds.",
      languages: "Any Language",
      languagesDesc:
        "Create songs in English, Spanish, Korean, Japanese, and many more languages.",
      customLyrics: "Custom Lyrics",
      customLyricsDesc:
        "Write your own lyrics or let AI generate them from your description.",
      commercial: "Commercial Use",
      commercialDesc:
        "Songs you create are yours. Use them for YouTube, TikTok, podcasts, and more.",
      lyricsIncluded: "Lyrics Included",
      lyricsIncludedDesc:
        "Every generated song comes with full written lyrics you can view and edit.",
      voiceCovers: "AI Voice Covers",
      voiceCoversDesc:
        "Re-sing a song in a new AI voice while keeping the original instrumental.",
    },
    whyChoose: "Why Choose Solmi AI",
    howItWorksTitle: "How It Works",
    faqTitle: "Frequently Asked Questions",
    exploreMore: "Explore More AI Music Tools",
  },

  // Director workspace (shared across Director.tsx + DirectorShell)
  director: {
    nav: {
      musicAnalysis: "Music Analysis",
      visualStyle: "Visual Style",
      creativeBrief: "Creative Brief",
      references: "References",
      choreography: "Choreography",
      shotList: "Shot List",
      storyboard: "Storyboard",
      render: "Render",
      movements: "Sections",
    },
    export: {
      initialize: "Initialize",
      preparingAssets: "Preparing assets...",
      renderVideo: "Render video",
      renderingFinalVideo: "Rendering final video...",
      processAudio: "Process audio",
      processingAudio: "Processing audio...",
      finalize: "Finalize",
      finalizingExport: "Finalizing export...",
      finalExport: "FINAL EXPORT",
      pleaseKeepOpen: "Please keep this tab open",
      downloadLastExport: "Download last export",
      exportMp4: "Download MP4",
      downloadMp4: "Download MP4",
      exporting: "Exporting",
    },
    loading: {
      project: "Loading your project…",
      listeningTrack: "Listening to the track…",
      preparingAnalysis: "Preparing the analysis…",
    },
    analysis: {
      tempo: "Tempo",
      tonalCenter: "Tonal center",
      length: "Length",
      integrated: "Integrated",
    },
    empty: {
      briefNotReady: "Creative brief not ready yet",
      waitingEarlierPhases: "Waiting on earlier phases",
      briefGenerateDesc:
        "Your song is analyzed. Keep the highlighted style or pick another one above, then generate the creative brief to continue.",
      briefWaitingDesc:
        "The creative brief is written once the music analysis is done and a visual style is chosen.",
      // Director (chat) mode only: the agent writes the brief when asked.
      briefDescChat:
        "Once music is analyzed and a style is locked in, ask the Director in chat to 'generate the brief' — or let the agent decide when it's ready.",
      noReferenceImages: "No reference images yet",
      referenceImagesDesc:
        "Once the brief is in place, the Director will generate character looks and location references.",
      waitingBrief: "Waiting on brief",
      briefReadyDesc:
        "The brief is ready. Generate the reference images to continue.",
      generateReferences: "Generate references",
      noShotList: "No shot list yet",
      shotListDesc:
        "Once references are ready, the Director will propose a shot-by-shot breakdown synced to the music.",
      waitingReferences: "Waiting on references",
      referencesReadyDesc:
        "References are ready. Generate the shot list to continue.",
      generateShotList: "Generate shot list",
      noStoryboard: "No storyboard yet",
      storyboardDesc:
        "After the shot list is locked, the agent renders first-frame images for every shot.",
      // Studio (no chat): the Storyboard card before / at its boundary.
      storyboardDescStudio:
        "A first-frame image is made for every shot once the shot list is ready.",
      storyboardReadyDesc:
        "The shot list is ready. Generate a first-frame image for every shot to continue.",
      waitingShots: "Waiting on shot list",
      noClips: "No clips rendered yet",
      clipsDesc:
        "Once the storyboard looks right, ask the Director to 'render the video'. Clips will appear here as they finish.",
      waitingStoryboard: "Waiting on storyboard",
      clipsDescStudio:
        "Once every shot has a storyboard frame, start the render at the Render step. Clips will appear here as they finish.",
      // Studio: the Render card once every shot has an up-to-date frame.
      renderReadyDesc:
        "Every shot has a storyboard frame. Render the video to turn them into clips; they appear here as they finish.",
    },
    // Phone (<1200px) bar that opens the Studio steps / Director chat sheet.
    mobileSheet: {
      nextSteps: "Next steps",
      askDirector: "Ask the Director",
      steps: "Steps",
      chat: "Chat",
      openSteps: "Open Studio steps",
      openChat: "Open Director chat",
      closeChat: "Close Director chat",
      closeSteps: "Close Studio steps",
    },
    // Studio "Choose the video length" picker (SongSegmentTrimmer) and the
    // preset chips / credit line Director.tsx builds for it.
    trimmer: {
      dialogLabel: "Select the song segment for your video",
      title: "Choose the video length",
      subtitle: "Shorter clips cost fewer credits.",
      format: "Format",
      landscape: "16:9 landscape",
      portrait: "9:16 portrait",
      quality: "Quality",
      settingsLocked:
        "Set for this project — use “Change the video length” to re-plan with different settings",
      audioUnavailableLabel: "Audio preview unavailable",
      audioUnavailable: "Audio preview unavailable.",
      playPreview: "Play preview",
      stopPreview: "Stop preview",
      seconds: "{{count}}s",
      confirm: "Confirm",
      estimating: "Estimating credits…",
      // {{label}} is the song section's own label from the analysis.
      presetSection: "{{label}} ({{range}})",
      presetSectionFallback: "Top section",
      presetPreview: "{{seconds}}s Preview ({{range}})",
      presetFirst60: "First 60s",
      presetFullSong: "Full song ({{seconds}}s)",
      presetCredits: "≈ {{count}} cr",
      presetCreditsCovered: "≈ {{count}} cr ✓",
      // {{credits}} is director.stepper.credits ("95 credits").
      lineCovered: "≈ {{credits}} ✓",
      lineShortfall: "≈ {{credits}} · {{shortfall}} more needed",
      lineRenderNeedsPlus: "≈ {{credits}} · rendering needs Plus",
      lineStoryboardNeedsPlus:
        "≈ {{credits}} · storyboard and rendering need Plus",
      lineNeedsPlus: "≈ {{credits}} · needs Plus",
      keepsScenes_one: "keeps {{count}} existing scene",
      keepsScenes_other: "keeps {{count}} existing scenes",
      freeTrim_one: "Free · keeps the {{count}} scene in range",
      freeTrim_other: "Free · keeps the {{count}} scenes in range",
      topUpCredits: "Top up credits",
      getPlus: "Get Plus",
    },
    // concept_cards_v1: song-aware idea cards on the Studio step before the
    // first brief, for projects that started with the idea left blank.
    conceptCards: {
      label: "Ideas for this song",
      writeOwn: "Write my own idea",
      ownPlaceholder: "What happens in your video?",
      loading: "Writing ideas for this song…",
    },
    // Studio canvas banners above the Shots / Storyboard / Render sections.
    // {{credits}} is director.stepper.credits ("10 credits").
    studioBanner: {
      lengthChangedShots:
        "Video length was changed by you — this shot list still covers the previous range (the brief already follows the new length).",
      lengthChangedStoryboard:
        "Video length was changed by you — this storyboard follows the previous range. Regenerating the shot list is the first step; new frames are then generated at the Storyboard step.",
      undoKeepLength: "Undo, keep current length",
      missingFrames_one:
        "{{count}} shot has no storyboard frame yet (new video range or edited shots)",
      missingFrames_other:
        "{{count}} shots have no storyboard frame yet (new video range or edited shots)",
      staleFrames_one:
        "{{count}} frame was generated from a reference you've since changed",
      staleFrames_other:
        "{{count}} frames were generated from a reference you've since changed",
      // {{details}} joins the lines above with " · ".
      framesSummary: "{{details}}. Up-to-date frames are kept.",
      missingClips_one: "{{count}} shot isn't rendered yet",
      missingClips_other: "{{count}} shots aren't rendered yet",
      staleClips_one: "{{count}} clip shows an older storyboard frame",
      staleClips_other: "{{count}} clips show an older storyboard frame",
      clipsSummary: "{{details}}. Up-to-date clips are kept.",
      generateFrames_one: "Generate {{count}} frame ({{credits}})",
      generateFrames_other: "Generate {{count}} frames ({{credits}})",
      generateAllFrames_one: "Generate all {{count}} frame ({{credits}})",
      generateAllFrames_other: "Generate all {{count}} frames ({{credits}})",
      renderClips_one: "Render {{count}} clip",
      renderClips_other: "Render {{count}} clips",
      renderClipsPriced_one: "Render {{count}} clip (~{{credits}})",
      renderClipsPriced_other: "Render {{count}} clips (~{{credits}})",
      onlyNewFrames_one: "Only {{count}} new frame ({{credits}})",
      onlyNewFrames_other: "Only {{count}} new frames ({{credits}})",
      onlyNewFramesTitle:
        "Generate only the frames that are missing or no longer match their shot text. Frames flagged for a changed reference are left as they are.",
      keepFrames_one: "Keep {{count}} frame",
      keepFrames_other: "Keep {{count}} frames",
      keepFramesTitle:
        "These frames still render fine — keep them as they are, for free, and stop flagging this reference change. A future reference change will flag them again.",
    },
    // Lip-sync amount under the Studio Shots "Generate shot list" button:
    // the stepper's chip ladder (shared/avatarScreenTimeCeiling.ts). The
    // chips append " (N%)" to the option names.
    lipSyncAmount: {
      summary: "Lip-sync: {{amount}}",
      label: "Lip-sync",
      change: "Change",
      default: "Default",
      none: "None",
      light: "Light",
      balanced: "Balanced",
      heavy: "Heavy",
      max: "Max",
    },
    brief: {
      concept: "Concept",
      archetype: "Archetype",
      rhythmDriver: "Rhythm Driver",
      visualStyle: "Visual Style",
      audience: "Audience",
    },
    referenceTypes: {
      character: "Character",
      look: "Look",
      location: "Location",
      supporting: "Supporting",
      reference: "Reference",
    },
    // References gallery + reference editor. Lead cards (character / look)
    // only steer the lead's identity and outfit; photos of other people go
    // in through Add person (additional characters).
    refs: {
      leadAttachTitle:
        "Reference for the lead's look. To add another person, use Add person.",
      leadAttachCaption:
        "Images added here are references for the lead's look only — they don't put another person in the video.",
      leadAttachDone:
        "Added as a look reference for the lead only. To put this person in the video, use Add person.",
      addPerson: "Add person",
      addPersonTitle:
        "Upload a photo of another person. They join the project as a Supporting character (free) and can appear in frames generated from now on.",
      addPersonDone:
        "Person added as a Supporting character. Frames generated from now on can include them; existing frames and clips are unchanged.",
    },
    firstClip: {
      render: "Render video ({{credits}} credits)",
      renderNoPrice: "Render video",
      renderAnyway: "Render anyway ({{credits}} credits)",
      rendering: "Rendering…",
      rendered: "Video ready",
    },
    lipSync: {
      tooShort: "This shot is under {{seconds}} second — too short to lip-sync.",
      helpOffShort: "Toggle on to make this shot sing along. Short shots render as a {{seconds}}-second lip-sync (billed as {{seconds}}s) and are trimmed to fit.",
      tooShortLastShot: "This shot is under {{seconds}} second — too short to lip-sync.",
      fallbackVocalUnreadable: "This clip was rendered without lip-sync: the vocal in this shot is too dense for the lip-sync model to follow word by word, so it was rendered as a performance shot and charged at the cinematic rate. Re-rendering will not change this.",
      fallbackFrozenV2: "Lip-sync could not be rendered for this shot, so it was replaced with a performance shot. If the replacement cost less than lip-sync, the difference was returned to your credits. Re-render the clip to try lip-sync again.",
      fallbackSilentVocals: "This clip was rendered without lip-sync: no singing was found in this shot's part of the song, so there was nothing to lip-sync.",
      fallbackLeadIn: "This clip was rendered without lip-sync: the singing starts {{leadSec}} s into this shot. Start the shot within about {{maxSec}} s of the first word (at {{wordSec}} s), then regenerate the video.",
      fallbackSparseVocals: "This clip was rendered without lip-sync: singing fills only {{coveragePct}}% of this shot. Shorten the shot to the sung part, then regenerate the video.",
      fallbackFacelessFrame: "This clip was rendered without lip-sync: the start image has no face for the lip-sync model to animate. Use an image with a clear face, then regenerate the video.",
      fallbackVocalsUnclear: "This clip was rendered without lip-sync: the singing in this shot was too quiet, too sparse, or started too late for lip-sync.",
      flaggedTakeRefundedThisClip: "This singing clip did not pass our check, so its credits were returned. Keep it or try again.",
      flaggedTakeRefunded: "Shot {{shot}}: this singing clip did not pass our check, so its credits were returned. Keep it or try again.",
      flaggedTakesRefunded: "Shots {{shots}}: these singing clips did not pass our check, so their credits were returned. Keep them or try again.",
      leadInWarning: "The singing starts {{leadSec}} s into this shot, so lip-sync will be skipped. Start the shot within about {{maxSec}} s of the first word (at {{wordSec}} s) before regenerating.",
      regenerateAnyway: "Regenerate anyway ({{credits}} credits)",
      pendingPromoteUpload: "Lip-sync is on and your uploaded picture will be used. Re-render the clip to make it sing.",
      uploadSetAsideSmallFace: "Your uploaded picture was set aside: the face is too small for singing. Upload a close-up and it will be used as it is.",
      uploadSetAsideNoFace: "Your uploaded picture was set aside: we could not find a clear face for singing. Upload a close-up and it will be used as it is.",
      startFrameSmallFace: "The face is small for singing. Use a close-up: face about a third of the picture height.",
    },
    vocalReadability: {
      suppressed: "This song's vocal is too dense for accurate lip-sync, so singing shots were planned as story shots. To try lip-sync anyway, pick a lip-sync amount or choose who sings, then regenerate the shot list.",
      unreadableKept: "This song's vocal is too dense for accurate lip-sync. You asked for singing shots, so they were kept — but mouths may not follow the words, and re-rendering will not fix that.",
      marginal: "This song's vocal is dense in places, so lip-sync may be less accurate on some singing shots.",
    },
    shots: {
      shot: "Shot",
      description: "Description",
      type: "Type",
      lipSync: "Lip Sync",
      cinematic: "Cinematic",
      lateSingingChip: "Singing starts late",
      tooLongChip: "Over {{maxSec}} s",
      tooLongWarning: "This shot is {{durationSec}} s long. A clip can be at most {{maxSec}} s, so its last {{overSec}} s would show a frozen frame. Shorten it to {{maxSec}} s or less.",
      startAtSinging: "Start at {{sec}} s",
    },
    ui: {
      timeline: "Timeline",
      newProject: "New Project",
      previousMovement: "Previous section",
      nextMovement: "Next section",
      continueToPhase: "Continue to {{phase}}",
      chooseStyleToContinue: "Choose a style to continue",
      clickToEdit: "Click to edit",
      previous: "Previous",
      next: "Next",
      close: "Close",
      generate: "Generate",
      regenerating: "Regenerating…",
      regenerateWithCredits: "Regenerate ({{credits}} credits)",
      newPictureWithCredits: "New picture ({{credits}} credits)",
      matchOutfitEverywhere: "Use this outfit in every shot",
      creativeDescription: "Creative Description",
    },
    toasts: {
      noProject: "No project to export",
      missingAudio: "Missing audio track",
      exportComplete: "Export complete. Download started.",
      exportConnectionDropped:
        "The connection dropped while the export was finishing. Checking for the finished file, this can take a few minutes.",
      exportStillFinishing:
        "The export is still finishing on our side. Reload the project in a few minutes; the Download button appears when the file is ready.",
      exportFailedOnServer:
        "The export did not complete on our side. Please try Export again.",
      briefMissing: "Brief missing — can't regenerate.",
      frameRegenerated: "Frame regenerated",
      frameRegeneratedClipReminder:
        "This shot's video clip still shows the previous frame. Open the Video tab and use Regenerate video to apply the change.",
      regenerationFailed: "Regeneration failed",
    },
    secondVoiceGate: {
      title: "We heard a second voice in this song",
      bodyMale: "This song seems to have a second (male) singer, but no photo was added for them. Add a photo for that singer so we can cast them — otherwise their parts will be covered with scenery shots instead of a singer.",
      bodyFemale: "This song seems to have a second (female) singer, but no photo was added for them. Add a photo for that singer so we can cast them — otherwise their parts will be covered with scenery shots instead of a singer.",
      bodyUnknown: "This song seems to have more than one singer, but only one performer has a photo. Add a photo for the other singer so we can cast them — otherwise their parts will be covered with scenery shots instead of a singer.",
      addPhoto: "Add singer photo",
      continueAnyway: "Continue with scenery",
      photoAdded: "Second singer photo added — their parts can now be cast.",
    },
    clipStale: {
      notice:
        "This shot's video clip was rendered from an older version of the frame. The updated frame only appears in the video after you regenerate this clip.",
      openVideoTab: "Open Video tab",
    },
    renderGate: {
      missingFrames_one:
        "{{count}} shot has no storyboard frame yet{{list}}. Generate the missing frame first.",
      missingFrames_other:
        "{{count}} shots have no storyboard frame yet{{list}}. Generate the missing frames first.",
      staleFrames_one:
        "{{count}} storyboard frame is outdated. Refresh the storyboard before rendering.",
      staleFrames_other:
        "{{count}} storyboard frames are outdated. Refresh the storyboard before rendering.",
    },
    // Studio stepper gate: the prompt asks for lip-sync but no shot sings.
    lipSyncGate: {
      title: "No shot is set to sing yet",
      body:
        "Your prompt asks for lip-sync, but none of the current shots is a lip-sync shot, so the performer's mouth will not move to the song. To fix it, open a shot's frame in the storyboard and turn on its Lip-sync switch, or regenerate the shot list. You can also render as-is.",
      back: "Go back",
      renderAnyway: "Render anyway",
    },
    // Studio stepper gate: the prompt mentions a photo but none is attached.
    photoRefGate: {
      title: "Your photo is not attached yet",
      body:
        "Your instructions mention a photo, but no photo is attached to this project, so every character would be invented by AI instead of matching your photo. Go back and upload it as the character reference, then generate again. You can also continue without it.",
      back: "Go back and add photo",
      continueAnyway: "Continue without photo",
    },
    // The Studio stepper's other inline gate cards (stepConfirm on
    // FastStepperPanel; worded in components/director/stepConfirmCopy.ts).
    // {{credits}} is director.stepper.credits ("12 credits"), {{shots}} a list
    // of shot codes ("S1.2, S3.1"), {{shot}} one code. Counts are i18next
    // plurals. The English is the pre-i18n copy verbatim, count quirks
    // included.
    gates: {
      cancel: "Cancel",
      goBack: "Go back",
      renderAnyway: "Render anyway",
      editedFrames: {
        title_one: "Replace {{count}} frame you edited by hand?",
        title_other: "Replace {{count}} frames you edited by hand?",
        body_one:
          "{{shots}} no longer matches the current scene text, but it contains edits you made by hand. Regenerating rebuilds it from the scene and look descriptions, which do NOT include those edits — your changes would be discarded. You can keep it and refresh only the other frames; hand-edited frames can be updated one at a time from the storyboard editor.",
        body_other:
          "{{shots}} no longer match the current scene text, but they contain edits you made by hand. Regenerating rebuilds them from the scene and look descriptions, which do NOT include those edits — your changes would be discarded. You can keep them and refresh only the other frames; hand-edited frames can be updated one at a time from the storyboard editor.",
        keep: "Keep my edits",
        replace: "Replace edited frames",
      },
      wardrobeLock: {
        titleFrames_one:
          "Match the outfit from {{shot}} in {{count}} frame for {{credits}}?",
        titleFrames_other:
          "Match the outfit from {{shot}} in {{count}} frames for {{credits}}?",
        titleShots_one: "Match the outfit from {{shot}} in {{count}} shot?",
        titleShots_other: "Match the outfit from {{shot}} in {{count}} shots?",
        outfit: "Outfit: {{phrase}}.",
        outfitFromEdit: "Outfit from your edit of {{shot}}: {{phrase}}.",
        nothingChanged: "Nothing has been changed or charged yet.",
        refine_one:
          "{{count}} existing frame ({{shots}}) will be refined toward this outfit, anchored to the current image so the composition stays — {{count}} × {{rate}} credits.",
        refine_other:
          "{{count}} existing frames ({{shots}}) will be refined toward this outfit, anchored to the current image so the composition stays — {{count}} × {{rate}} credits.",
        textOnly_one:
          "{{count}} shot without a frame yet ({{shots}}) get the outfit in their text for free.",
        textOnly_other:
          "{{count}} shots without a frame yet ({{shots}}) get the outfit in their text for free.",
        handEdited_one:
          "{{count}} of the frames to refine is hand-edited ({{shots}}).",
        handEdited_other:
          "{{count}} of the frames to refine are hand-edited ({{shots}}).",
        alreadyMatching_one:
          "{{count}} shot already describe this outfit and stay untouched.",
        alreadyMatching_other:
          "{{count}} shots already describe this outfit and stay untouched.",
        alreadyMatchingFrames_one:
          '{{count}} shot already describe this outfit and stay untouched — if their images still show a different outfit, choose "{{button}}" ({{credits}} total).',
        alreadyMatchingFrames_other:
          '{{count}} shots already describe this outfit and stay untouched — if their images still show a different outfit, choose "{{button}}" ({{credits}} total).',
        alsoRefresh: "Also refresh matching frames",
        alsoRefreshPriced: "{{button}} ({{credits}})",
        matchOutfit: "Match outfit",
        updateShotText: "Update shot text",
      },
      storyboardCost: {
        title_one: "Generate {{count}} storyboard frame for {{credits}}?",
        title_other: "Generate {{count}} storyboard frames for {{credits}}?",
        nothingGenerated: "Nothing has been generated or charged yet.",
        reused_one: "{{count}} existing frame will be reused for free.",
        reused_other: "{{count}} existing frames will be reused for free.",
        recentRuns:
          "This project already ran {{count}} full storyboard generations in the last few hours — another full run will likely look similar unless the shot list or references actually changed.",
      },
      renderRebuy: {
        title_one:
          "Render {{count}} clip for {{credits}}?",
        title_other:
          "Render {{count}} clips for {{credits}}?",
        rerender_one:
          "{{count}} clip you already have is rendered again because its frame changed: {{shots}}.",
        rerender_other:
          "{{count}} clips you already have are rendered again because their frames changed: {{shots}}.",
        newClips_one:
          "{{count}} shot has no clip yet.",
        newClips_other:
          "{{count}} shots have no clip yet.",
        nothingRendered:
          "Nothing has been rendered or charged yet.",
        oneShotTip:
          "To redo one shot only, open its frame, switch to Video and use \"Regenerate video\".",
        confirm_one:
          "Render {{count}} clip",
        confirm_other:
          "Render {{count}} clips",
      },
      extendShotList: {
        title: "Extend the shot list to the new video length?",
        body:
          "Your current {{count}} shots — with their storyboard frames and rendered clips — are kept. New shots are planned only for the added part of the song. This regenerates the shot list now; you generate the new frames (and render) afterwards, with prices shown first.",
        confirm: "Extend shot list",
      },
      discardFrames: {
        title_one: "Replace {{count}} storyboard frame?",
        title_other: "Replace {{count}} storyboard frames?",
        titleAll_one: "Replace ALL {{count}} storyboard frame?",
        titleAll_other: "Replace ALL {{count}} storyboard frames?",
        entireVideo:
          "This regenerates the plan for the ENTIRE video — your whole storyboard, every scene, will be discarded, not just the part being edited.",
        body:
          "Only the shot list is regenerated now — you run the storyboard and render steps yourself afterwards, with prices shown first. But frames belong to their shots, so {{discarded}} from the old plan will be discarded.",
        bodyWithClips:
          "Only the shot list is regenerated now — you run the storyboard and render steps yourself afterwards, with prices shown first. But frames and clips belong to their shots, so {{discarded}} from the old plan will be discarded.",
        frames_one: "{{count}} storyboard frame",
        frames_other: "{{count}} storyboard frames",
        clips_one: "{{count}} rendered clip",
        clips_other: "{{count}} rendered clips",
        framesAndClips: "{{frames}} and {{clips}}",
        keep: "Keep current frames",
        confirm: "Regenerate shot list",
      },
      casting: {
        title: "Performer doesn't match this section's voice",
        femaleVoice:
          "This section of the song ({{start}}–{{end}}) is sung by a female voice, but the performer is set to Male.",
        maleVoice:
          "This section of the song ({{start}}–{{end}}) is sung by a male voice, but the performer is set to Female.",
        body:
          "{{conflict}} If you continue, the performer will lip-sync a voice that doesn't sound like them. You can change the performer in the Voice presentation setting, select a different part of the song, or render anyway.",
      },
    },
    stylePanel: {
      intro:
        "Director's picks for this track come first, with the full style library below — every style is selectable. Each style steers the creative brief, reference images, and storyboard frames.",
    },
    styles: {
      "cinematic-realistic": {
        name: "HD Digital Film",
        description: "Cinematic · Realistic · Film Grain",
      },
      "euphoria-inspired": {
        name: "Euphoria Style Inspired",
        description: "Euphoria · Neon · Narrative Photography",
      },
      "wong-karwai": {
        name: "Wong Kar-wai Inspired",
        description: "Film Grain · Nostalgic · Street",
      },
      "abstract-artistic": {
        name: "Holiday Atmosphere",
        description: "Romantic · Warm · Holiday",
      },
      "kpop-commercial": {
        name: "K-Pop Performance Editorial",
        description: "K-Pop · Performance Editorial · Stagewear",
      },
      "led-dance-studio": {
        name: "LED Dance Studio",
        description: "Dance Studio · LED Wall · Crisp",
      },
      "street-dance-film": {
        name: "Street Dance Film",
        description: "Street Dance · Urban · Golden Hour",
      },
      "arena-tour-stage": {
        name: "Arena Tour Stage",
        description: "Concert · Light Beams · Arena",
      },
      "dance-theatre-minimal": {
        name: "Dance Theatre Minimal",
        description: "Contemporary · Black Box · Sculptural Light",
      },
      "film-noir": {
        name: "Classic Film Noir",
        description: "Film Noir · B&W · Classic",
      },
      "love-actually": {
        name: "Love Actually Inspired",
        description: "Romantic · Cinematic · Warm",
      },
      "shunji-iwai": {
        name: "Shunji Iwai Inspired",
        description: "Japanese · Nostalgic · Soft",
      },
      "dreamy-ethereal": {
        name: "Cloudlight Reverie",
        description: "Dreamy · Pastel · Soft Focus",
      },
      "dark-moody": {
        name: "Afterhours Gloom",
        description: "Dark · Moody · Fog",
      },
      "minidv-confessional": {
        name: "MiniDV Confessional",
        description: "Camcorder · Diary · Raw",
      },
      "cyberpunk-noir": {
        name: "Metro Tech Noir",
        description: "Cyberpunk · Noir · Rain",
      },
      "soft-toybox-3d": {
        name: "Soft Toybox 3D",
        description: "Pastel 3D · Cute · Surreal",
      },
      "ink-wash-memory": {
        name: "Ink Wash Memory",
        description: "Ink · Paper · Poetic",
      },
      "collage-pop-diary": {
        name: "Collage Pop Diary",
        description: "Zine · Cutout · Pop",
      },
      "clay-dream-studio": {
        name: "Clay Dream Studio",
        description: "Clay · Stop Motion · Handmade",
      },
      "grainy-gradient": {
        name: "Grainy Gradient",
        description: "Abstract · Airbrush · Noise",
      },
      "liminal-motel": {
        name: "Liminal Motel",
        description: "Empty Rooms · Night · Unease",
      },
      "desert-mirage": {
        name: "Desert Mirage",
        description: "Sun Bleached · Western · Heat",
      },
      "liquid-chrome-futurism": {
        name: "Liquid Chrome Futurism",
        description: "Chrome · Sci-Fi · Reflective",
      },
      "baroque-stage": {
        name: "Baroque Stage",
        description: "Ornate · Theatrical · Gold",
      },
    },
    phases: {
      analyze: { epigraph: "listen, before you see", note: "I. Overture" },
      style: {
        epigraph: "choose the key you'll play in",
        note: "II. Key Signature",
      },
      brief: { epigraph: "a score, in prose", note: "III. Libretto" },
      refs: {
        epigraph: "the faces that will sing",
        note: "IV. Dramatis Personae",
      },
      shots: { epigraph: "every beat, its own stanza", note: "V. Measures" },
      storyboard: {
        epigraph: "freeze the music into light",
        note: "VI. Preludes",
      },
      render: { epigraph: "let the picture move", note: "VII. Performance" },
    },
    musicAnalysis: {
      bpm: "BPM",
      keyLabel: "Key",
      duration: "Duration",
      loudness: "Loudness",
      beatGrid: "Beat Grid",
      downbeats: "downbeats",
      cutPoints: "cut points",
      sectionMap: "Section Map",
      detected: "Detected {{value}}",
      notDetected: "Not detected",
      unknownKey: "Unknown",
      tempoKeySaved: "Saved. The next shot list will use it.",
      tempoKeySaveFailed: "Could not save the change.",
    },
    // Markdown summaries returned by tool calls. Rendered in the chat
    // thread; preserve **bold**, emoji, and {{placeholders}}.
    summary: {
      storyboardReady: "🎨 **Storyboard Ready ({{count}} frames)**",
      storyboardExtended:
        "🎨 **Storyboard Extended ({{total}} frames total, {{added}} new)**",
      storyboardDescription:
        "First-frame images are on the Storyboard phase. Review them before rendering the full video.",
      videoReady: "🎬 **{{label}} ready** ({{seconds}}s)",
      videoRange: "Range: {{startSec}}s – {{endSec}}s",
      downloadMp4: "[Download MP4]({{url}})",
      // analyze_music tool
      musicAnalysisHeader: "🎵 **Music Analysis Complete**",
      tempoLine: "- **Tempo:** {{bpm}} BPM",
      keyLine: "- **Key:** {{key}}",
      durationLine: "- **Duration:** {{seconds}}s",
      emotionalArcLine: "- **Emotional arc:** {{arc}}",
      sectionsHeader: "**Sections:**",
      sectionLine: "- **{{label}}** ({{start}}–{{end}}s)",
      alreadyAnalyzed:
        "Music already analyzed: {{bpm}} BPM, key {{key}}, {{seconds}}s.",
      // Soft pasted-replacement-lyrics warning (en-only; other languages
      // fall back to en via fallbackLng).
      lyricsMismatchWarning:
        "⚠️ **Heads-up:** the lyrics pasted in your prompt don't match what this track actually sings. Sung lyrics come from your uploaded audio and can't be changed here — to use new lyrics, first generate a new song with them (or upload a re-recorded version), then create the video from that.",
      lyricsMismatchToast:
        "The lyrics pasted in your prompt don't match this song. Sung lyrics come from the uploaded audio and can't be changed here — generate a new song with your new lyrics first, or upload the re-recorded version.",
      // select_style tool
      styleSelected: "Selected **{{name}}** as the visual style.",
    },
    budget: {
      checkOk: "💰 **Budget check ✅**",
      checkTrialOk: "💰 **Budget check ✅ — free trial covers this cut**",
      checkTrialShort:
        "💰 **Budget check ⚠️ — free trial covers this cut, {{shortfall}} credits short**",
      checkShort: "💰 **Budget check ⚠️ — {{shortfall}} short**",
      totalProjected:
        "- Estimated cost: **{{total}} credits** · Your balance: **{{current}} credits**",
      trialCovers:
        "- Your one-time {{seconds}}s music video trial covers **{{covered}} credits** for this eligible cut.",
      chargeable:
        "- Estimated chargeable remaining cost: **{{credits}} credits**.",
      breakdown:
        "- Breakdown: analyze {{a}} · brief {{b}} · references {{r}} · shot list {{sl}} · storyboard {{sb}} · render {{rn}}",
      renderPricingExact:
        "- Render: cinematic {{pix}} credits/sec, avatar/lip-sync {{ltx}} credits/sec (rounded up per shot).",
      renderPricingEstimate:
        "- Render estimated at {{pix}} credits/sec until the shot list is final.",
      affordHint:
        "- With your current balance you could afford up to **~{{shots}} shots** (~{{seconds}}s of music).",
    },
    // "Behind the Scenes" substeps — the small checklist under each tool
    // card that summarizes what the tool did. Most lines are static text.
    // Lines that interpolate values from the tool output use {{count}},
    // {{name}}, etc.
    substeps: {
      selectStyle: {
        matched: "Matched the requested style against the visual library.",
        lockedNamed: "Locked in **{{name}}** as the project's visual style.",
        locked: "Locked in the chosen visual style.",
      },
      analyzeMusic: {
        prepared: "Prepared the audio file for analysis.",
        detected: "Detected BPM, key, and the section map.",
        transcribed: "Transcribed vocals and mapped the emotional arc.",
      },
      generateBrief: {
        fed: "Fed the analysis and chosen style into the brief writer.",
        draftedTitled: "Drafted the brief with working title **{{title}}**.",
        drafted:
          "Drafted the creative brief: title, concept, energy map, and looks.",
      },
      generateReferences: {
        preparedCount: "Prepared **{{count}}** reference cards.",
        prepared: "Prepared a duration-scaled reference set.",
        characterBase: "Prepared the character base reference.",
        looksCount: "Generated **{{count}}** character look references.",
        looksOne: "Generated **{{count}}** character look reference.",
        looks: "Generated character look references.",
        locationsCount: "Generated **{{count}}** location references.",
        locationsOne: "Generated **{{count}}** location reference.",
        locations: "Generated location references.",
      },
      generateShotList: {
        plannedRange:
          "Planned the shot list for the trimmed range **{{range}}**.",
        planned: "Planned the shot list across the full song.",
        aligned: "Aligned shots to sections, beats, and lyric lines.",
        producedCount: "Produced **{{count}}** shots grouped into scenes.",
        produced: "Produced the scene → shot breakdown.",
      },
      generateStoryboard: {
        queuedCount: "Queued **{{count}}** first-frame prompts.",
        queued: "Queued the first-frame prompts.",
        conditioned:
          "Conditioned each frame on the chosen references for consistency.",
        saved: "Saved every storyboard image to the canvas.",
      },
      renderVideo: {
        dispatchedCount: "Dispatched **{{count}}** shots for video generation.",
        dispatched: "Dispatched each shot for video generation.",
        lipsync: "Ran lipsync on clips that contain vocals.",
        stitched:
          "Stitched every finished clip back into the project timeline.",
      },
      retryShots: {
        diffed: "Diffed existing render results against the shot list.",
        retriedCount: "Re-rendered **{{count}}** requested shots.",
        retriedOne: "Re-rendered **{{count}}** requested shot.",
        retried: "Re-rendered the requested shots.",
        mergedCount:
          "Merged back into the timeline — **{{count}}** clips ready.",
        merged: "Merged the retries back into the timeline.",
      },
      estimateCost: {
        computed:
          "Computed per-stage credit cost from the current project state.",
        projected:
          "Projected **{{total}}** credits total · balance **{{current}}**.",
        compared:
          "Compared the projected total against the current credit balance.",
        suggestedTrim:
          "Suggested a trim to ~{{seconds}}s ({{shots}} shots) that fits the budget.",
        budgetFits: "Budget fits — no trim suggestion needed.",
      },
      defaultRan: "Ran the **{{tool}}** tool.",
    },
    // Free-form action chips the agent emits at decision points (not in
    // the static quick-reply set). Match against these patterns at render
    // time to display the localized version while sending the original
    // English label back to the agent.
    actionChips: {
      subscribeToGetCredits: "Subscribe to get credits",
      subscribeToMakeVideo: "Subscribe to make a music video",
      subscribeToContinueLonger: "Subscribe to continue longer",
      topUpCredits: "Top up credits",
      looksGoodBuildShotList: "Everything looks good - build shot list",
      looksGoodRenderAll: "Everything looks good - generate all shot videos now",
      adjustReferenceImage: "Adjust a reference image",
      adjustStoryboardImage: "Adjust a storyboard image",
      editVideoClip: "Edit a video clip",
      downloadVideo: "Download video",
      retry: "Retry",
      tryAgain: "Try again",
      retryFailedShots: "Retry the failed shots",
      theFullSong: "The full song",
      fullSongNeedsCredits: "The full song (needs credits)",
      quickTeaser: "A quick teaser (15-20s)",
      shortVersion: "A short version (20-60s)",
      shortVersionNeedsCredits: "A short version (20-60s, needs credits)",
      halfTheSong: "Half the song (~60-90s)",
      letDirectorPick: "Or let the director pick",
      requestChange: "I'd like to request a change",
      startNewProject: "Start a new project",
      extendToFullSong: "Extend to the full song",
      previewCovered: "Preview (~{{sec}}s) — covered by your credits",
      renderCoveredPreview: "Render the covered preview (~{{sec}}s) instead",
      renderTheVideo: "Render the video",
      generateTheStoryboard: "Generate the storyboard",
      generateTheBrief: "Generate the brief",
      buildTheShotList: "Build the shot list",
      generateReferences: "Generate references first",
      retryStoryboard: "Retry missing storyboard images",
      analyzeMyMusic: "Analyze my music",
      extendVideo: "Extend video",
    },
    chat: {
      directorName: "Director",
      online: "online",
      behindScenes: "Behind the Scenes",
      statusDone: "done",
      statusRunning: "running…",
      thinking: "Director is thinking…",
      waitingReview: "Director is waiting for your review.",
      projectStarted: "— Project started —",
      placeholder: "Ask the director anything…",
      continue: "Continue",
      silentTurnFallback: "Done — the result is shown above. Tell me what you'd like to adjust, or tap Continue to move on.",
      silentTurnFallbackNext: "Tell me what you'd like to adjust, or tap Continue to move on.",
      autoContinueStalled: "I couldn't finish narrating that step — the results above are saved. Tell me what you'd like to adjust, or tap Continue to move on.",
      keepsRunningIfYouLeave: "This keeps going if you leave the page — you can come back to this project later.",
      continueWithStyle: "Continue with {{style}}",
      retryStoryboard: "Retry missing storyboard images",
      videoReady: "Your video is ready.",
      download: "Download",
      requestChange: "Request change",
      requestChangeMsg: "I'd like to request a change",
      requestChangeTypeHint: "Type the change you want below, then send it.",
      newProject: "New project",
      startNew: "Start a new project",
      extendTrialQuestion:
        "Want to extend this {{seconds}}s trial into a longer music video?",
      extendVideo: "Extend video",
      estimateCoveredPreviewHint:
        "Your current credits already cover a ~{{seconds}}s preview — you can render it without buying anything.",
      readOnly:
        "Read-only project. Only the owner can edit or chat with Director.",
      somethingWrong: "Something went wrong.",
      failed: "Failed",
      downloadFailed: "Download failed",
      copied: "Copied",
      thanks: "Thanks for the feedback",
      tryHarder: "Got it — I'll try harder",
      ariaCopy: "Copy",
      ariaGood: "Good response",
      ariaBad: "Bad response",
      selectedCutLabel: "Selected cut: {{range}}",
      selectedCutHint:
        "New plans and edits cover only this range. Remove it to use the full song.",
      clearSelectedCut: "Use the full song",
    },
    chips: {
      howStart: "How do I get started?",
      whatHelp: "What can you help with?",
      analyzeMusic: "Analyze my music",
      whatExtract: "What will you extract?",
      whichStyle: "Which style fits best?",
      surpriseStyle: "Surprise me with a style",
      explainDifferences: "Explain the differences",
      generateBrief: "Generate the brief",
      moodyCinematic: "Make it moody and cinematic",
      buildShots: "Build the shot list",
      referencesFirst: "Generate references first",
      retryStoryboard: "Retry missing storyboard images",
      whatFailed: "What failed?",
      generateStoryboard: "Generate the storyboard",
      continue: "Continue",
      renderVideo: "Render the video",
      howLong: "How long will it take?",
      tiktokCut: "Give me a 15s TikTok cut",
      howDownload: "How do I download?",
      whatsNext: "What's next?",
      summarize: "Summarize my project",
      // Avatar/lip-sync ratio chips emitted by the agent. The chip values
      // include a percentage (e.g. "Default avatar/lip-sync (32%)") that the
      // agent uses to call generate_shot_list. We translate the lead-in text
      // but preserve the original English label as the click target.
      lipSyncDefault: "Default avatar/lip-sync ({{pct}}%)",
      lipSyncNone: "No avatar/lip-sync (0%)",
      lipSyncLight: "Light avatar/lip-sync ({{pct}}%)",
      lipSyncBalanced: "Balanced avatar/lip-sync ({{pct}}%)",
      lipSyncPerformanceHeavy: "Performance-heavy avatar/lip-sync ({{pct}}%)",
      lipSyncMostly: "Mostly avatar/lip-sync ({{pct}}%)",
      lipSyncMax: "Max avatar/lip-sync ({{pct}}%)",
      lipSyncOldDefault: "Default lip-sync ({{pct}}%)",
      lipSyncOldBalance: "Default balance ({{pct}}%)",
    },
    tools: {
      selectStyle: { title: "Select style", running: "Applying style…" },
      analyzeMusic: {
        title: "Analyze music",
        running: "Analyzing music (1–2 min)…",
      },
      generateBrief: {
        title: "Generate creative brief",
        running: "Writing the brief (about 1 min)…",
      },
      generateChoreography: {
        title: "Plan choreography",
        running: "Planning choreography…",
      },
      generateReferences: {
        title: "Generate reference images",
        running: "Generating references (10–30s)…",
      },
      editShot: {
        title: "Edit shots",
        running: "Updating the shot list…",
      },
      generateShotList: {
        title: "Generate shot list",
        running: "Building the shot list (30s–2 min)…",
      },
      generateStoryboard: {
        title: "Generate storyboard",
        running: "Generating storyboard (20–60s)…",
      },
      renderVideo: {
        title: "Render video",
        running: "Rendering video clips (1–3 min)…",
      },
      retryShots: {
        title: "Retry failed shots",
        running: "Re-rendering requested shots…",
      },
      estimateCost: {
        title: "Estimate credit cost",
        running: "Projecting pipeline cost…",
      },
    },
    // Studio stepper (FastStepperPanel): the right-hand panel in Studio mode
    // and the "Next steps" sheet on mobile web. Step titles come from
    // director.nav.*, "Continue to …" from director.ui.continueToPhase.
    // Counts are i18next plurals: give each form your language uses
    // (_one/_few/_many/_other), or just the bare key when all forms read the
    // same. The English is the pre-i18n copy verbatim, count quirks included.
    aspectVariant: {
      title: "Make a {{aspect}} version?",
      newProject: "This starts a new project with the same story, cast and scenes. Your {{source}} video stays as it is.",
      rerender: "Every frame and clip is rendered again at {{aspect}}, so the result can look different from your {{source}} video.",
      estimateLabel: "Estimated cost",
      estimate: "~{{credits}} credits",
      estimateUnavailable: "Shown before each step",
      chargedLater: "Charged when you generate the frames and clips, not now.",
      balanceShort: "You have {{credits}} credits. Add more before rendering.",
      confirm: "Create {{aspect}} project",
    },
    stepper: {
      stepDetail: {
        analysis: "Tempo, key, sections, and lyrics of your track.",
        style: "The look that steers the brief, references, and frames.",
        brief: "The written concept: story, character looks, energy arc.",
        choreography: "Movement language, palette, and a motif per section.",
        references: "Character and location reference images.",
        shotlist: "Scene-by-scene shots timed to the song.",
        storyboard: "A first-frame image for every shot.",
        render: "Generate the clips and export the final MP4.",
      },
      editStep: "Edit {{step}}",
      studioTag: "Studio",
      workflow: "Workflow",
      studioMode: "Studio mode",
      danceMode: "Dance mode",
      switchToDirectorTitle:
        "Drive this project with the Director chat instead — all progress carries over",
      untitled: "Untitled",
      renameProject: "Rename project",
      creditsLeft_one: "{{count}} credit left",
      creditsLeft_other: "{{count}} credits left",
      creditsLeftTitle: "Your remaining credit balance",
      toFinish: "~{{credits}} to finish",
      working: "Working…",
      credits: "{{count}} credits",
      free: "free",
      change: "Change",
      outdatedFrameBadge: "Outdated frame: regenerate",
      outdatedFrameTitle:
        "Outdated frame: this shot's description changed after the image was made. Regenerate it before rendering.",
      regenLengthChanged: "Video length changed — needs regenerate",
      regenFrames_one: "{{count}} frame to regenerate",
      regenFrames_other: "{{count}} frames to regenerate",
      regenClips_one: "{{count}} clip to re-render",
      regenClips_other: "{{count}} clips to re-render",
      notPlannedYet: "Not planned yet",
      metaReferences_one: "{{count}} reference",
      metaReferences_other: "{{count}} references",
      metaShots: "{{count}} shots",
      metaFrames: "{{count}} frames",
      metaClips_one: "{{count}} clip",
      metaClips_other: "{{count}} clips",
      metaExported: "exported",
      sectionsChip: "{{count}} sections",
      analysisIntro:
        "Analyzes your track (tempo, key, sections, and lyrics) so every later step can sync to the music.",
      videoCovers: "Video covers",
      fullSong: "Full song",
      notChosenYet: "Not chosen yet",
      analyzeMusic: "Analyze music",
      chooseVideoLength: "Choose video length",
      visualStyleLabel: "Visual style",
      recommended: "Recommended for this track. Pick one or keep the first.",
      recommendedDance:
        "Recommended for dance: crisp, full-body looks first. Pick one or keep the first.",
      styleChangeRewritesBrief:
        "Changing the style after the brief exists rewrites the brief for free.",
      briefStyle: "Style: {{style}}",
      briefIntro:
        "Writes the creative concept from the analysis and chosen style: story, character looks, locations, and energy arc.",
      generateBrief: "Generate creative brief",
      choreographySummary: "{{summary}} · full plan on the canvas",
      choreographyIntro:
        "Solmi plans the movement language, a move palette, and a motif, groove, and energy arc for every section of the song. Lip-sync hero shots stay on for the sung lines.",
      planChoreography: "Plan choreography",
      replanWithNotes: "Re-plan with notes",
      replanTitle: "Re-plan the choreography with notes (free revision)",
      generatingReferences: "Generating reference images…",
      generatingReferencesReady:
        "Generating reference images… {{count}} ready.",
      generateReferences: "Generate references",
      // Label above the lip-sync chips (names: director.lipSyncAmount.*).
      lipSyncLabel: "Lip-sync (singing close-up) amount",
      lipSyncNotApplied:
        "Lip-sync (singing close-up) amount — not applied yet: regenerate the shot list below",
      lipSyncAppliesOnRegen:
        "Lip-sync (singing close-up) amount — applies when the shot list is regenerated",
      shotSings: "Sings",
      shotDance: "Dance",
      shotCinematic: "Cinematic",
      shotsPlannedFullSong_one:
        "{{count}} shot planned for the full song. Review them on the canvas, then continue.",
      shotsPlannedFullSong_other:
        "{{count}} shots planned for the full song. Review them on the canvas, then continue.",
      shotsPlannedRange_one:
        "{{count}} shot planned for {{range}}. Review them on the canvas, then continue.",
      shotsPlannedRange_other:
        "{{count}} shots planned for {{range}}. Review them on the canvas, then continue.",
      shotListIntro:
        "Plans the scene-by-scene shots timed to the music. The video length is set at the {{step}} step.",
      shotListIntroRange:
        "Plans the scene-by-scene shots timed to the music for {{range}} ({{seconds}}s). The video length is set at the {{step}} step.",
      lengthChangedShotList:
        'Video length was changed by you, but this shot list still covers the previous range. Use "{{button}}" below to update it (the brief already follows the new length).',
      generateShotList: "Generate shot list",
      regenerateToApplyLipSync: "Regenerate to apply lip-sync change",
      continueWithoutApplying: "Continue without applying",
      generateStoryboardWithoutApplying: "Generate storyboard without applying",
      regenerateForLength: "Regenerate for current video length",
      regenerateUnchanged:
        "Shot list unchanged: it already fits the current video length. No credits used.",
      generateStoryboard: "Generate storyboard",
      lengthChangedStoryboard:
        "This storyboard follows the previous video length. Regenerate the shot list first ({{step}} step) so rendering matches the new range.",
      cascadeFrames_one:
        "{{count}} storyboard frame show the character you just updated.",
      cascadeFrames_other:
        "{{count}} storyboard frames show the character you just updated.",
      cascadeClips_one:
        "{{count}} rendered clip will also re-render at the next render step (~{{credits}}).",
      cascadeClips_other:
        "{{count}} rendered clips will also re-render at the next render step (~{{credits}}).",
      refreshAffectedFrames: "Refresh affected frames ({{credits}})",
      keepAsIs: "Keep as is",
      generateMissingFrames_one: "Generate {{count}} missing or outdated frame",
      generateMissingFrames_other:
        "Generate {{count}} missing or outdated frames",
      storyboardShortfallPaid_one:
        "You have {{count}} credit — about {{shortfall}} more are needed to storyboard and render the full video.",
      storyboardShortfallPaid_other:
        "You have {{count}} credits — about {{shortfall}} more are needed to storyboard and render the full video.",
      storyboardShortfallFreeNeed_one:
        "You have {{count}} credit — about {{shortfall}} more are needed to storyboard and render the full video. Everything you've designed is saved.",
      storyboardShortfallFreeNeed_other:
        "You have {{count}} credits — about {{shortfall}} more are needed to storyboard and render the full video. Everything you've designed is saved.",
      renderShortfallFreeNeed_one:
        "You have {{count}} credit — about {{shortfall}} more are needed to render the full video. Everything you've designed is saved.",
      renderShortfallFreeNeed_other:
        "You have {{count}} credits — about {{shortfall}} more are needed to render the full video. Everything you've designed is saved.",
      addCreditsShort: "Add credits",
      storyboardShortfallFree_one:
        "You have {{count}} credit. Everything you've designed is saved — finishing the storyboard and render needs more credits.",
      storyboardShortfallFree_other:
        "You have {{count}} credits. Everything you've designed is saved — finishing the storyboard and render needs more credits.",
      storyboardPreviewNote:
        "This renders about {{count}} seconds of the selected song range using your credits, including the storyboard. The rest of the video is not rendered yet.",
      renderOpeningPreview:
        "Render opening ~{{seconds}}s preview, covered by your credits",
      renderVideo: "Render video",
      renderFullVideo: "Render full video",
      renderFirstPreview: "Render first ~{{seconds}}s preview",
      topUpAndRender: "Top up & render full video",
      addCreditsToRender: "Add credits to render your video",
      previewFirstBalance_one:
        "You have {{count}} credit. Preview the opening first; you can render the remaining shots later from the {{step}} step.",
      previewFirstBalance_other:
        "You have {{count}} credits. Preview the opening first; you can render the remaining shots later from the {{step}} step.",
      renderShortfallPaid_one:
        "You have {{count}} credit — about {{shortfall}} more are needed for the full video.",
      renderShortfallPaid_other:
        "You have {{count}} credits — about {{shortfall}} more are needed for the full video.",
      renderShortfallFree_one:
        "You have {{count}} credit. Everything you've designed is saved — rendering is the only step that needs more credits.",
      renderShortfallFree_other:
        "You have {{count}} credits. Everything you've designed is saved — rendering is the only step that needs more credits.",
      renderPreviewNote:
        "This renders about {{count}} seconds of the selected song range using your credits. The rest of the video is not rendered yet; extending it requires more credits.",
      previewReplacesVideoConfirm:
        "Your current {{current}}s video will be replaced by a {{seconds}}s preview, and the shots outside the preview will be removed from this project. Cancel to keep your video. Replace it?",
      addCaptions: "Add captions to the video",
      addCaptionsTitle:
        "Burn styled lyrics into the exported video (changing the style later is a free re-export)",
      applyCaptions: "Apply captions: {{style}}",
      applyCaptionsTitle:
        "Burn the lyrics you picked into the video — free re-export, no re-render",
      previewCaptionStyle: "Preview or change the style first",
      captionsApplied: "Captions: {{style}}",
      captionsPicked: "Captions picked: {{style}} — applies after render",
      clipsReady: "{{done}}/{{total}} clips ready",
      clipsRendering: "{{count}} rendering",
      clipsFailed: "{{count}} failed",
      checkClipsTitle: "Check your first clips before rendering more",
      checkClipsSinging:
        "Play a singing clip: does the right person sing, do their lips follow the words, and does their face match your reference? For a duet, check a clip from each singer’s part.",
      checkClipsFix:
        "Correct the affected shot before extending the video. Editing its text or performer is free; regenerating its image or video uses credits.",
      reviewShotAssignments: "Review shot assignments",
      exportingMp4: "Exporting final MP4… {{percent}}%",
      download: "Download",
      makeAspectVersion: "Make a {{aspect}} version",
      aspectVersionTitleVertical:
        "Same story, cast and scenes, reframed for Shorts, Reels and TikTok. Frames and clips render again.",
      aspectVersionTitleWide:
        "Same story, cast and scenes, reframed for YouTube. Frames and clips render again.",
      renderRemaining: "Render remaining videos",
      exportRenderedPart: "Export rendered part only",
      exportFinalVideo: "Export final video",
      retryFailedShots: "Retry failed shots",
      downloadCurrentVideo: "Download current video",
      lastExportStale:
        "Your last export, made before the changes above — regenerate to get an updated video.",
    },
  },

  // DirectorHome page
  directorHome: {
    picker: {
      pickTrack: "Pick a track",
      attached: "Attached",
      selectSong: "Select a song",
      pasteLink: "Paste a {{platform}} link",
      describe: "Describe it",
      optional: "Optional",
      describePlaceholder: "A mood, a place, a reference. Anything.",
      tryExample: "Try an example",
      tryExampleHint: "Drops an example into the box; click again for the next one",
      example1: "Neon-lit night drive through Tokyo",
      example2: "Handheld Super 8, beach at golden hour",
      example3: "One-take black and white performance",
      chooseLook: "Choose a look",
      mostPopular: "Most popular",
      allStyles: "All {{count}} styles",
      allStylesTitle: "All visual styles",
      viewAll: "View all styles",
      lookCount: "{{count}} looks",
      auto: "Auto",
      autoHint: "Suggested after analysis",
      defaultTag: "Default",
      makeMusicVideo: "Make music video",
      dancePlaceholder: "Dance style, mood, setting, wardrobe. Anything.",
      makeDanceVideo: "Make dance video",
    },
    hero: {
      title: "Turn any song into a",
      titleHighlight: "music video.",
      subtitle:
        "Bring a song. Our agent drafts the treatment, casts the cast, and renders the final cut.",
    },
    topBarTitle: "Music Video",
    attach: {
      addMusic: "Attach a song",
      musicAttached: "Music attached",
      specs:
        "MP3 · WAV · M4A · MP4 up to 200MB — MP4 export in 16:9 / 9:16, up to 1080p · typical render 3–10 min",
      required: "required",
      remove: "Remove",
      ariaLabel: "Attach music",
      pasteLink: "Paste a link",
      linkPlaceholder: "YouTube / TikTok / SoundCloud / MP3 URL…",
      fetching: "Fetching",
      attach: "Attach",
      extractingAudio:
        "Extracting audio from {{source}} — this can take 10–30s.",
      or: "OR",
      uploadFile: "Upload a file",
      fileTypes: "MP3 · WAV · M4A · MP4 · up to 200MB",
      uploading: "Uploading…",
      sunoGuide: {
        title: "Could not import that Suno song",
        body: "Publish the song in Suno and make sure the link is public, then try attaching it again.",
        step1: "Open song in Suno",
        step2: "Already public? Try again, or download the MP3 and upload it below.",
        step3: "Drop the MP3 below (or tap to choose it)",
        dropHere: "Drop your Suno MP3 here",
      },
    },
    mySongs: {
      title: "My songs",
      signIn: "Sign in to pick from your existing tracks.",
      loading: "Loading…",
      noTracks: "No tracks yet.",
      untitled: "Untitled",
    },
    promptPlaceholder:
      "Describe the music video you want — mood, palette, characters, any moment you want to land.",
    promptPlaceholderNoTrack:
      "Describe the music video you want, once you have a track attached.",
    audioAsIsNotice:
      "Heads up: Solmi creates the video for your attached audio as-is — it can't change the song, rewrite lyrics, or make new or alternate versions of the track.",
    directVideo: "Create Music Video",
    directVideoAttachFirst: "Attach a Song to Start",
    references: "Images",
    refCount: "{{count}} ref",
    refCountPlural: "{{count}} refs",
    genres: {
      singingMv: "Singing MV",
      storyMv: "Story MV",
      abstractMv: "Abstract MV",
      viralShorts: "Viral Shorts",
      onbeatEffects: "Onbeat Effects",
    },
    toasts: {
      uploadingAudio: "Uploading audio…",
      audioUploaded: "Audio uploaded",
      uploadFailed: "Upload failed",
      invalidUrl: "Please paste a valid URL (https://…)",
      extractingFrom: "Extracting audio from {{source}}…",
      attachedFrom: "Attached from {{source}}",
      couldNotExtract:
        "Could not extract audio from that link. Try another source.",
      spotifyNotSupported:
        "Spotify links only provide a 30-second preview, so they're no longer supported. Upload the audio file or paste a YouTube link instead.",
      attachSong: "Attach a song to start directing",
      invalidAudioUrl: "Please include a valid audio URL (https://…)",
    },
  },
  promptImageTags: {
    menuLabel: "Tag a photo",
    menuHint: "Insert a photo tag, then say how it's used",
    roleLead: "Lead singer · {{name}}",
    roleCharacter: "Character · {{name}}",
    roleVibe: "Vibe · {{name}}",
    hintOne:
      "Tip: type @ to tag your photo and say how it's used, e.g. \"@{{first}} sings the whole song\".",
    hintTwo:
      "Tip: type @ to tag a photo and say how it's used, e.g. \"@{{first}} is the singer, @{{second}} is the location\".",
  },
  // On-page lyrics generator on the lyric tool pages (LyricsToolGenerator).
  freeLyricsTool: {
    writing: "Writing…",
    copy: "Copy",
    copied: "Lyrics copied",
    copyFailed: "Couldn't copy. Your browser blocked clipboard access.",
    regenerate: "Regenerate",
    toSong: "Turn these lyrics into a song",
    error: "Couldn't write the lyrics. Please try again.",
  },
};
